// Import the new roads-sewers mock data
import { rsSumAnalysis } from "./rs-sum-analysis";
import { rsFoulSewers } from "./rs-foul-sewers";

const manholeRatesByDiameter = {
  "1200mm": [
    { name: "1200mm dia ave 1.00m dti", depth: "1.00m", rate: 1831.36 },
    { name: "1200mm dia ave 1.25m dti", depth: "1.25m", rate: 2026.24 },
    { name: "1200mm dia ave 1.50m dti", depth: "1.50m", rate: 2248.3 },
    { name: "1200mm dia ave 1.75m dti", depth: "1.75m", rate: 2498.78 },
    { name: "1200mm dia ave 2.00m dti", depth: "2.00m", rate: 2721.24 },
    { name: "1200mm dia ave 2.25m dti", depth: "2.25m", rate: 2916.16 },
    { name: "1200mm dia ave 2.50m dti", depth: "2.50m", rate: 3138.18 },
    { name: "1200mm dia ave 2.75m dti", depth: "2.75m", rate: 3388.68 },
    { name: "1200mm dia ave 3.00m dti", depth: "3.00m", rate: 4174.54 },
    { name: "1200mm dia ave 3.25m dti", depth: "3.25m", rate: 4425.77 },
    { name: "1200mm dia ave 3.50m dti", depth: "3.50m", rate: 4704.15 },
    { name: "1200mm dia ave 3.75m dti", depth: "3.75m", rate: 5010.97 },
    { name: "1200mm dia ave 4.00m dti", depth: "4.00m", rate: 5289.77 },
    { name: "1200mm dia ave 4.25m dti", depth: "4.25m", rate: 5541.01 },
    { name: "1200mm dia ave 4.50m dti", depth: "4.50m", rate: 5819.37 },
    { name: "1200mm dia ave 4.75m dti", depth: "4.75m", rate: 6097.83 },
    { name: "1200mm dia ave 5.00m dti", depth: "5.00m", rate: 6405.01 },
    { name: "1200mm dia ave 5.25m dti", depth: "5.25m", rate: 6656.25 },
    { name: "1200mm dia ave 5.50m dti", depth: "5.50m", rate: 6934.63 },
    { name: "1200mm dia ave 5.75m dti", depth: "5.75m", rate: 7241.45 },
    { name: "1200mm dia ave 6.00m dti", depth: "6.00m", rate: 7520.26 },
  ],
  "1350mm": [
    { name: "1350mm dia ave 1.00m dti", depth: "1.00m", rate: 1900.0 },
    { name: "1350mm dia ave 1.25m dti", depth: "1.25m", rate: 2100.0 },
    { name: "1350mm dia ave 1.50m dti", depth: "1.50m", rate: 2300.0 },
    { name: "1350mm dia ave 1.75m dti", depth: "1.75m", rate: 2500.0 },
    { name: "1350mm dia ave 2.00m dti", depth: "2.00m", rate: 2700.0 },
    { name: "1350mm dia ave 2.25m dti", depth: "2.25m", rate: 2900.0 },
    { name: "1350mm dia ave 2.50m dti", depth: "2.50m", rate: 3100.0 },
    { name: "1350mm dia ave 2.75m dti", depth: "2.75m", rate: 3300.0 },
    { name: "1350mm dia ave 3.00m dti", depth: "3.00m", rate: 3500.0 },
    { name: "1350mm dia ave 3.25m dti", depth: "3.25m", rate: 3700.0 },
    { name: "1350mm dia ave 3.50m dti", depth: "3.50m", rate: 3900.0 },
    { name: "1350mm dia ave 3.75m dti", depth: "3.75m", rate: 4100.0 },
    { name: "1350mm dia ave 4.00m dti", depth: "4.00m", rate: 4300.0 },
    { name: "1350mm dia ave 4.25m dti", depth: "4.25m", rate: 4500.0 },
    { name: "1350mm dia ave 4.50m dti", depth: "4.50m", rate: 4700.0 },
    { name: "1350mm dia ave 4.75m dti", depth: "4.75m", rate: 4900.0 },
    { name: "1350mm dia ave 5.00m dti", depth: "5.00m", rate: 5100.0 },
    { name: "1350mm dia ave 5.25m dti", depth: "5.25m", rate: 5300.0 },
    { name: "1350mm dia ave 5.50m dti", depth: "5.50m", rate: 5500.0 },
    { name: "1350mm dia ave 5.75m dti", depth: "5.75m", rate: 5700.0 },
    { name: "1350mm dia ave 6.00m dti", depth: "6.00m", rate: 5900.0 },
  ],
};

const pipeworkRatesByDiameter = {
  "150mm": [
    { name: "150mmØ pipeX1.00mdeep", depth: "1.00m", rate: 78.74, unit: "m" },
    { name: "150mmØ pipeX1.25mdeep", depth: "1.25m", rate: 104.14, unit: "m" },
    { name: "150mmØ pipeX1.50mdeep", depth: "1.50m", rate: 128.74, unit: "m" },
    { name: "150mmØ pipeX1.75mdeep", depth: "1.75m", rate: 154.14, unit: "m" },
    { name: "150mmØ pipeX2.00mdeep", depth: "2.00m", rate: 178.75, unit: "m" },
    { name: "150mmØ pipeX2.25mdeep", depth: "2.25m", rate: 204.15, unit: "m" },
    { name: "150mmØ pipeX2.50mdeep", depth: "2.50m", rate: 266.33, unit: "m" },
    { name: "150mmØ pipeX2.75mdeep", depth: "2.75m", rate: 296.45, unit: "m" },
    { name: "150mmØ pipeX3.00mdeep", depth: "3.00m", rate: 326.58, unit: "m" },
    { name: "150mmØ pipeX3.25mdeep", depth: "3.25m", rate: 356.7, unit: "m" },
    { name: "150mmØ pipeX3.50mdeep", depth: "3.50m", rate: 386.86, unit: "m" },
    { name: "150mmØ pipeX3.75mdeep", depth: "3.75m", rate: 416.96, unit: "m" },
    { name: "150mmØ pipeX4.00mdeep", depth: "4.00m", rate: 447.11, unit: "m" },
    { name: "150mmØ pipeX4.25mdeep", depth: "4.25m", rate: 477.2, unit: "m" },
    { name: "150mmØ pipeX4.50mdeep", depth: "4.50m", rate: 507.34, unit: "m" },
    { name: "150mmØ pipeX4.75mdeep", depth: "4.75m", rate: 537.48, unit: "m" },
    { name: "150mmØ pipeX5.00mdeep", depth: "5.00m", rate: 567.61, unit: "m" },
    { name: "150mmØ pipeX5.25mdeep", depth: "5.25m", rate: 597.73, unit: "m" },
    { name: "150mmØ pipeX5.50mdeep", depth: "5.50m", rate: 627.86, unit: "m" },
    { name: "150mmØ pipeX5.75mdeep", depth: "5.75m", rate: 657.98, unit: "m" },
    { name: "150mmØ pipeX6.00mdeep", depth: "6.00m", rate: 688.13, unit: "m" },
    {
      name: "EO for 150mmØ stub/rocker pipe",
      depth: null,
      rate: 13.77,
      unit: "m",
    },
    {
      name: "EO for impermeable geotextile membrane wrap to 150mmØ pipe",
      depth: null,
      rate: 6.25,
      unit: "m",
    },
    {
      name: "EO for reinforced concrete protection paving to 150mmØ pipe",
      depth: null,
      rate: 82.19,
      unit: "m",
    },
  ],
  "225mm": [
    { name: "225mmØ pipeX1.00mdeep", depth: "1.00m", rate: 115.64, unit: "m" },
    { name: "225mmØ pipeX1.25mdeep", depth: "1.25m", rate: 142.1, unit: "m" },
    { name: "225mmØ pipeX1.50mdeep", depth: "1.50m", rate: 169.38, unit: "m" },
    { name: "225mmØ pipeX1.75mdeep", depth: "1.75m", rate: 195.84, unit: "m" },
    { name: "225mmØ pipeX2.00mdeep", depth: "2.00m", rate: 223.11, unit: "m" },
    { name: "225mmØ pipeX2.25mdeep", depth: "2.25m", rate: 249.57, unit: "m" },
    { name: "225mmØ pipeX2.50mdeep", depth: "2.50m", rate: 299.84, unit: "m" },
    { name: "225mmØ pipeX2.75mdeep", depth: "2.75m", rate: 329.97, unit: "m" },
    { name: "225mmØ pipeX3.00mdeep", depth: "3.00m", rate: 360.09, unit: "m" },
    { name: "225mmØ pipeX3.25mdeep", depth: "3.25m", rate: 390.22, unit: "m" },
    { name: "225mmØ pipeX3.50mdeep", depth: "3.50m", rate: 420.35, unit: "m" },
    { name: "225mmØ pipeX3.75mdeep", depth: "3.75m", rate: 450.48, unit: "m" },
    { name: "225mmØ pipeX4.00mdeep", depth: "4.00m", rate: 480.61, unit: "m" },
    { name: "225mmØ pipeX4.25mdeep", depth: "4.25m", rate: 510.72, unit: "m" },
    { name: "225mmØ pipeX4.50mdeep", depth: "4.50m", rate: 540.85, unit: "m" },
    { name: "225mmØ pipeX4.75mdeep", depth: "4.75m", rate: 570.98, unit: "m" },
    { name: "225mmØ pipeX5.00mdeep", depth: "5.00m", rate: 601.11, unit: "m" },
    { name: "225mmØ pipeX5.25mdeep", depth: "5.25m", rate: 631.24, unit: "m" },
    { name: "225mmØ pipeX5.50mdeep", depth: "5.50m", rate: 661.36, unit: "m" },
    { name: "225mmØ pipeX5.75mdeep", depth: "5.75m", rate: 691.49, unit: "m" },
    { name: "225mmØ pipeX6.00mdeep", depth: "6.00m", rate: 721.62, unit: "m" },
  ],
};
const lateralRates = {
  "150mm": [
    {
      name: "150mmØ pipework, GBS, backfilled with Type 1, deposit surplus material on site",
      depth: null,
      unit: "m",
      rate: null,
    },
    { name: "150mmØ pipeX1.00mdeep", depth: "1.00m", unit: "m", rate: 78.74 },
    { name: "150mmØ pipeX1.25mdeep", depth: "1.25m", unit: "m", rate: 104.14 },
    { name: "150mmØ pipeX1.50mdeep", depth: "1.50m", unit: "m", rate: 128.74 },
    { name: "150mmØ pipeX1.75mdeep", depth: "1.75m", unit: "m", rate: 154.14 },
    { name: "150mmØ pipeX2.00mdeep", depth: "2.00m", unit: "m", rate: 178.75 },
    { name: "150mmØ pipeX2.25mdeep", depth: "2.25m", unit: "m", rate: 204.15 },
    { name: "150mmØ pipeX2.50mdeep", depth: "2.50m", unit: "m", rate: 266.33 },
    { name: "150mmØ pipeX2.75mdeep", depth: "2.75m", unit: "m", rate: 296.45 },
    { name: "150mmØ pipeX3.00mdeep", depth: "3.00m", unit: "m", rate: 326.58 },
    { name: "150mmØ pipeX3.25mdeep", depth: "3.25m", unit: "m", rate: 356.7 },
    { name: "150mmØ pipeX3.50mdeep", depth: "3.50m", unit: "m", rate: 386.86 },
    { name: "150mmØ pipeX3.75mdeep", depth: "3.75m", unit: "m", rate: 416.96 },
    { name: "150mmØ pipeX4.00mdeep", depth: "4.00m", unit: "m", rate: 447.11 },
    { name: "150mmØ pipeX4.25mdeep", depth: "4.25m", unit: "m", rate: 477.2 },
    { name: "150mmØ pipeX4.50mdeep", depth: "4.50m", unit: "m", rate: 507.34 },
    { name: "150mmØ pipeX4.75mdeep", depth: "4.75m", unit: "m", rate: 537.48 },
    { name: "150mmØ pipeX5.00mdeep", depth: "5.00m", unit: "m", rate: 567.61 },
    { name: "150mmØ pipeX5.25mdeep", depth: "5.25m", unit: "m", rate: 597.73 },
    { name: "150mmØ pipeX5.50mdeep", depth: "5.50m", unit: "m", rate: 627.86 },
    { name: "150mmØ pipeX5.75mdeep", depth: "5.75m", unit: "m", rate: 657.98 },
    { name: "150mmØ pipeX6.00mdeep", depth: "6.00m", unit: "m", rate: 688.13 },
    {
      name: "EO for 150mmØ stub/rocker pipe",
      depth: null,
      unit: "nr",
      rate: 13.77,
    },
    {
      name: "EO for concrete bed & surround to 150mmØ pipe",
      depth: null,
      unit: "m",
      rate: 30.06,
    },
  ],
};

const gulliesRates = {
  "150mm": [
    {
      name: "150mmØ pipework, GBS, backfilled with Type 1, deposit surplus material on site",
      depth: null,
      unit: "m",
      rate: null,
    },
    { name: "150mmØ pipeX1.00mdeep", depth: "1.00m", unit: "m", rate: 78.74 },
    { name: "150mmØ pipeX1.25mdeep", depth: "1.25m", unit: "m", rate: 104.14 },
    { name: "150mmØ pipeX1.50mdeep", depth: "1.50m", unit: "m", rate: 128.74 },
    { name: "150mmØ pipeX1.75mdeep", depth: "1.75m", unit: "m", rate: 154.14 },
    { name: "150mmØ pipeX2.00mdeep", depth: "2.00m", unit: "m", rate: 178.75 },
    { name: "150mmØ pipeX2.25mdeep", depth: "2.25m", unit: "m", rate: 204.15 },
    { name: "150mmØ pipeX2.50mdeep", depth: "2.50m", unit: "m", rate: 266.33 },
    { name: "150mmØ pipeX2.75mdeep", depth: "2.75m", unit: "m", rate: 296.45 },
    { name: "150mmØ pipeX3.00mdeep", depth: "3.00m", unit: "m", rate: 326.58 },
    { name: "150mmØ pipeX3.25mdeep", depth: "3.25m", unit: "m", rate: 356.7 },
    { name: "150mmØ pipeX3.50mdeep", depth: "3.50m", unit: "m", rate: 386.86 },
    { name: "150mmØ pipeX3.75mdeep", depth: "3.75m", unit: "m", rate: 416.96 },
    { name: "150mmØ pipeX4.00mdeep", depth: "4.00m", unit: "m", rate: 447.11 },
    { name: "150mmØ pipeX4.25mdeep", depth: "4.25m", unit: "m", rate: 477.2 },
    { name: "150mmØ pipeX4.50mdeep", depth: "4.50m", unit: "m", rate: 507.34 },
    { name: "150mmØ pipeX4.75mdeep", depth: "4.75m", unit: "m", rate: 537.48 },
    { name: "150mmØ pipeX5.00mdeep", depth: "5.00m", unit: "m", rate: 567.61 },
    { name: "150mmØ pipeX5.25mdeep", depth: "5.25m", unit: "m", rate: 597.73 },
    { name: "150mmØ pipeX5.50mdeep", depth: "5.50m", unit: "m", rate: 627.86 },
    { name: "150mmØ pipeX5.75mdeep", depth: "5.75m", unit: "m", rate: 657.98 },
    { name: "150mmØ pipeX6.00mdeep", depth: "6.00m", unit: "m", rate: 688.13 },
    {
      name: "EO for 150mmØ stub/rocker pipe",
      depth: null,
      unit: "nr",
      rate: 13.77,
    },
    {
      name: "EO for concrete bed & surround to 150mmØ pipe",
      depth: null,
      unit: "m",
      rate: 30.06,
    },
  ],
};

const roadRates = {
  siteClearanceEarthworks: [
    {
      item: "1.0",
      category: "SITE CLEARANCE & EARTHWORKS",
      items: [
        {
          description: "Site strip to remove vegetation",
          unit: "m²",
          rate: 1.41,
        },
        {
          description:
            "Excavate to reduce levels to take up 296mm top soil, deposit onsite",
          unit: "m³",
          rate: 5.76,
        },
      ],
    },
  ],
  excavatingFilling: [
    {
      item: "2.0",
      category: "EXCAVATING & FILLING",
      items: [
        { description: "Excavate to reduce levels", unit: "m³", rate: 5.76 },
        {
          description: "Filling with site won subsoil to paths",
          unit: "m³",
          rate: 8.09,
        },
        {
          description: "Filling with recycled 6F2 to roads",
          unit: "m³",
          rate: 49.71,
        },
        {
          description: "Level and compact formation",
          unit: "m²",
          rate: 0.94,
        },
      ],
    },
  ],
  carriageway: [
    {
      item: "3.1",
      category: "Macadam Access Road",
      items: [
        { description: "225mm thick MOT Type 1", unit: "m²", rate: 16.66 },
        {
          description: "125mm thick AC 32mm DBM base course",
          unit: "m²",
          rate: 37.17,
        },
        {
          description: "60mm thick AC 20mm DBM binder course",
          unit: "m²",
          rate: 17.84,
        },
        { description: "Sealing grit", unit: "m²", rate: 0.72 },
        { description: "Sweep tack", unit: "m²", rate: 1.03 },
        {
          description: "40mm thick HRA 55/10F (n ex psv60) surface course",
          unit: "m²",
          rate: 19.29,
        },
      ],
    },
    {
      item: "3.2",
      category: "Block Paved Access Way",
      items: [
        { description: "225mm thick MOT Type 1", unit: "m²", rate: 16.66 },
        {
          description: "125mm thick AC 32mm DBM base course",
          unit: "m²",
          rate: 37.17,
        },
        { description: "Sealing grit", unit: "m²", rate: 0.72 },
        { description: "Sweep", unit: "m²", rate: 0.39 },
        {
          description: "200 x 100 x 80mm block paviour on 30mm sand bed",
          unit: "m²",
          rate: 48.37,
        },
        {
          description:
            "EO retrofit ramp in delineation from macadam to block paved",
          unit: "nr",
          rate: 1364.35,
        },
        {
          description: "EO form joint to existing carriageway - if required",
          unit: "m",
          rate: 43.01,
        },
      ],
    },
  ],
  footpathsCrossoversVerges: [
    {
      item: "4.1",
      category: "Tarmac Footpath",
      items: [
        { description: "200mm thick MOT Type 1", unit: "m²", rate: 14.8 },
        {
          description: "80mm thick AC 20mm DBM binder course",
          unit: "m²",
          rate: 34.26,
        },
        { description: "Sweep tack", unit: "m²", rate: 1.03 },
        {
          description: "20mm thick AC 6mm DBM surface course",
          unit: "m²",
          rate: 16.21,
        },
      ],
    },
    {
      item: "4.2",
      category: "Tarmac Crossover",
      items: [
        { description: "200mm thick MOT Type 1", unit: "m²", rate: 14.8 },
        {
          description: "80mm thick AC 20mm DBM binder course",
          unit: "m²",
          rate: 34.46,
        },
        { description: "Sweep tack", unit: "m²", rate: 1.03 },
        {
          description: "25mm thick AC 6mm DBM surface course",
          unit: "m²",
          rate: 17.05,
        },
      ],
    },
    {
      item: "4.3",
      category: "Verges",
      items: [
        {
          description: "Spread and level 150mm thick top soil",
          unit: "m²",
          rate: 3.25,
        },
        {
          description: "EO for bodpave verge reinforcement - Usual WCC spec",
          unit: "m²",
          rate: 12.5,
        },
      ],
    },
  ],
  kerbsEdgings: [
    {
      item: "5.0",
      category: "KERBS & EDGINGS",
      items: [
        {
          description: "Pcc Kerbs - All Sizes",
          unit: "m",
          rate: 18.75,
        },
        {
          description: "EO for xxmmØ dowel to kerb race at xxxmm ccs",
          unit: "nr",
          rate: 3.5,
        },
        {
          description: "Channel Kerbs to Block Paved Ramps",
          unit: "m",
          rate: 22.5,
        },
        {
          description:
            "Temporary macadam fillet to drive crossover prior to road surfacing",
          unit: "m",
          rate: 15.0,
        },
        {
          description: "Remove macadam fillet upon completion",
          unit: "m",
          rate: 8.0,
        },
        {
          description: "150 x 50 pcc edging",
          unit: "m",
          rate: 12.25,
        },
        {
          description: "Tactiles",
          unit: "m²",
          rate: 85.0,
        },
      ],
    },
  ],
  adjustIronwork: [
    {
      item: "6.0",
      category: "ADJUST IRONWORK PRIOR TO FINAL SURFACING",
      items: [
        {
          description: "Manholes",
          unit: "nr",
          rate: 125.0,
        },
        {
          description: "Gully covers and frames",
          unit: "nr",
          rate: 75.0,
        },
        {
          description: "Stop Tap Boxes",
          unit: "nr",
          rate: 65.0,
        },
        {
          description: "BT / Virgin footway boxes",
          unit: "nr",
          rate: 55.0,
        },
      ],
    },
  ],
  whiteLining: [
    {
      item: "7.0",
      category: "WHITE LINING",
      items: [
        {
          description: "White lining - various",
          unit: "m",
          rate: 2.5,
        },
      ],
    },
  ],
  streetNameplates: [
    {
      item: "8.0",
      category: "FIX-ONLY STREET NAMEPLATES",
      items: [
        {
          description: "Fix-only street nameplates",
          unit: "nr",
          rate: 45.0,
        },
      ],
    },
  ],
  streetFurniture: [
    {
      item: "9.0",
      category: "TREE PITS, BOLLARDS & STREET FURNITURE",
      items: [
        {
          description: "Tree pits, bollards & street furniture",
          unit: "nr",
          rate: 250.0,
        },
      ],
    },
  ],
  remedials: [
    {
      item: "10.0",
      category: "REMEDIALS",
      items: [
        {
          description: "Remedial works",
          unit: "nr",
          rate: 500.0,
        },
      ],
    },
  ],
};

const mainServicesRates = [
  {
    item: "1.0",
    category: "MAIN SERVICE TRENCHING",
    items: [
      { description: "Water main trenching", unit: "m", rate: 25.32 },
      { description: "Road crossing duct n ex 150mmØ", unit: "m", rate: 67.77 },
      { description: "Electric LV main trenching", unit: "m", rate: 23.41 },
      { description: "Road crossing duct n ex 150mmØ", unit: "m", rate: 67.77 },
      {
        description: "Electric HV main trenching to substation",
        unit: "m",
        rate: 23.41,
      },
      {
        description: "Substation base & maintenance drive",
        unit: null,
        rate: null,
      },
      { description: "Gas main trenching", unit: "m", rate: 23.41 },
      { description: "BT main ducting", unit: "m", rate: 20.57 },
      { description: "Road crossing duct n ex 150mmØ", unit: "m", rate: 67.77 },
      { description: "BT Joint Box JBF 104", unit: "nr", rate: 478.23 },
      {
        description: "BT Joint Box JBF 104C 750mm deep",
        unit: "nr",
        rate: 998.95,
      },
      {
        description: "BT Joint Box JBF 106D 900 deep",
        unit: "nr",
        rate: 1160.52,
      },
      {
        description: "BT Joint Box JBF 106 1200 deep",
        unit: "nr",
        rate: 1545.27,
      },
      {
        description: "BT Joint Box JBF 104 (utilising pre-formed Stakkabox)",
        unit: "nr",
        rate: 791.69,
      },
      {
        description:
          "BT Joint Box JBF 104C 750mm deep (utilising pre-formed Stakkabox)",
        unit: "nr",
        rate: 1167.74,
      },
      {
        description:
          "BT Joint Box JBF 106D 900 deep (utilising pre-formed Stakkabox)",
        unit: "nr",
        rate: 1338.86,
      },
      {
        description:
          "BT Joint Box JBF 106 1200 deep (utilising pre-formed Stakkabox)",
        unit: "nr",
        rate: 1770.84,
      },
      { description: "Virgin Media main ducting", unit: "m", rate: 20.57 },
      { description: "Virgin Footway Box FW4", unit: "nr", rate: 824.02 },
      { description: "Virgin Footway Box FW6", unit: "nr", rate: 1151.37 },
      { description: "Virgin Footway Box FW10", unit: "nr", rate: 1815.39 },
      { description: "Streetlighting main", unit: "m", rate: 23.41 },
      { description: "Streetlight connection pits", unit: "nr", rate: 561.13 },
      { description: "Streetlights & columns", unit: null, rate: null },
      { description: "Road crossing duct n ex 150mmØ", unit: "m", rate: 67.9 },
      { description: "225mmØ duct", unit: "m", rate: 88.94 },
      { description: "300mmØ duct", unit: "m", rate: 115.58 },
      { description: "450mmØ duct", unit: "m", rate: null },
      { description: "600mmØ duct", unit: "m", rate: null },
      {
        description:
          "EO for excavating service trenches off site in 'live' footway",
        unit: "m",
        rate: 189.58,
      },
    ],
  },
];

const groundworksPreEliminairesRates = [
  {
    items: [
      {
        description: "Engineer setting out houses and garages",
        unit: "item",
        rate: 75.0,
      },
    ],
  },
];

const preEliminairesRates = [
  {
    item: "1.0",
    category: "METHOD RELATED ITEMS",
    items: [
      {
        description: "Principal Contractor - Fixed Costs",
        unit: "item",
        rate: 18045.0,
      },
      {
        description: "Principal Contractor - Weekly Costs",
        unit: "wks",
        rate: 2395.0,
      },
      { description: "S106 applications", unit: "item", rate: 1000.0 },
      { description: "License to discharge", unit: "item", rate: 1000.0 },
      { description: "S50 applications", unit: "item", rate: 1100.0 },
      { description: "CBR tests", unit: "item", rate: 2461.0 },
      {
        description: "Binder and grading analysis",
        unit: "item",
        rate: 2040.0,
      },
      { description: "NDT's", unit: "item", rate: 2500.0 },
      { description: "Core testing", unit: "item", rate: 3243.33 },
      {
        description: "Jetting & CCTV of installed sewers; once",
        unit: "item",
        rate: 9195.0,
      },
      {
        description: "Cleaning of manholes prior to surfacing",
        unit: "item",
        rate: 4930.0,
      },
      {
        description: "Cleaning of gullies prior to surfacing",
        unit: "item",
        rate: 3520.0,
      },
    ],
  },
  {
    item: "2.0",
    category: "TREE PROTECTION FENCING",
    items: [],
  },
  {
    item: "2.1",
    category: "Tree Protection Fencing As BS 5837:2012 Figure 3a",
    items: [
      {
        description: "Supply of heras, rubber feet, clips and stabiliser strut",
        unit: "m",
        rate: 21.44,
      },
      { description: "Erect heras fencing on feet", unit: "m", rate: 7.43 },
      {
        description: "Dismantle heras fencing upon completion",
        unit: "m",
        rate: 7.43,
      },
    ],
  },
  {
    item: "2.2",
    category: "High Intensity Tree Protection Barrier",
    items: [
      {
        description: "Supply of heras, scaffold poles, couplers & ties",
        unit: "m",
        rate: 44.37,
      },
      { description: "Erect heras fencing on poles", unit: "m", rate: 37.75 },
      {
        description: "Dismantle heras fencing upon completion",
        unit: "m",
        rate: 28.95,
      },
    ],
  },
  {
    item: "3.0",
    category: "BOUNDARY PROTECTION FENCING",
    items: [
      {
        description: "Supply of heras, rubber feet & clips",
        unit: "m",
        rate: 15.98,
      },
      { description: "Erect heras fencing on feet", unit: "m", rate: 6.75 },
      {
        description: "Dismantle heras fencing upon completion",
        unit: "m",
        rate: 6.75,
      },
    ],
  },
];

export {
  manholeRatesByDiameter,
  pipeworkRatesByDiameter,
  lateralRates,
  gulliesRates,
  roadRates,
  mainServicesRates,
  preEliminairesRates,
  groundworksPreEliminairesRates,
};

export const ForecastByProject = {
  projectName: "Bayston",
  projectStagesAndTasksByRun: [
    {
      id: 1,
      selectedWeek: "Week 27 (Jul 1 - Jul 6)",
      run: "1",
      stage: "Earth Works",
      tasks: [
        "Topsoil Strip",
        "Cut & Engineered Fill",
        "Spoil Management (Bulk Files)",
      ],
    },
    {
      id: 2,
      selectedWeek: "Week 27 (Jul 1 - Jul 6)",
      run: "1",
      stage: "Sewers & Roads (Stage 1)",
      tasks: ["Storm water Manholes", "Stormwater Laterals"],
    },
  ],
  budgetForecasts: {
    totalLabourCosts: 10000,
    totalPlantCost: 15000,
    totalMaterialCost: 20000,
    totalSubContractorCost: 25000,
  },
};

export const groundworksRates = {
  trenchfill: {
    bbFoundations: [
      {
        name: "External Wall foundation at 1.30m wide",
        sizeInMeters: 1.3,
        unit: "m",
        rate: 146.7,
      },
      {
        name: "Party Wall foundation at 1.30m wide",
        sizeInMeters: 1.3,
        unit: "m",
        rate: 138.34,
      },
      {
        name: "Internal Wall foundation at 1.30m wide",
        sizeInMeters: 1.3,
        unit: "m",
        rate: 107.29,
      },
      {
        name: "Garage External Wall foundation at 1.30m wide",
        sizeInMeters: 1.3,
        unit: "m",
        rate: 109.61,
      },
      {
        name: "Garage Internal Wall foundation at 1.30m wide",
        sizeInMeters: 1.3,
        unit: "m",
        rate: 101.65,
      },
      {
        name: "External Wall foundation at 1.20m wide",
        sizeInMeters: 1.2,
        unit: "m",
        rate: 144.92,
      },
      {
        name: "Party Wall foundation at 1.20m wide",
        sizeInMeters: 1.2,
        unit: "m",
        rate: 142.71,
      },
      {
        name: "Internal Wall foundation at 1.20m wide",
        sizeInMeters: 1.2,
        unit: "m",
        rate: 109.73,
      },
      {
        name: "Garage External Wall foundation at 1.20m wide",
        sizeInMeters: 1.2,
        unit: "m",
        rate: 106.2,
      },
      {
        name: "Garage Internal Wall foundation at 1.20m wide",
        sizeInMeters: 1.2,
        unit: "m",
        rate: 106.97,
      },
      {
        name: "External Wall foundation at 1.10m wide",
        sizeInMeters: 1.1,
        unit: "m",
        rate: 147.59,
      },
      {
        name: "Party Wall foundation at 1.10m wide",
        sizeInMeters: 1.1,
        unit: "m",
        rate: 143.44,
      },
      {
        name: "Internal Wall foundation at 1.10m wide",
        sizeInMeters: 1.1,
        unit: "m",
        rate: 109.3,
      },
      {
        name: "Garage External Wall foundation at 1.10m wide",
        sizeInMeters: 1.1,
        unit: "m",
        rate: 105.13,
      },
      {
        name: "Garage Internal Wall foundation at 1.10m wide",
        sizeInMeters: 1.1,
        unit: "m",
        rate: 104.63,
      },
      {
        name: "External Wall foundation at 1.00m wide",
        sizeInMeters: 1.0,
        unit: "m",
        rate: 146.23,
      },
      {
        name: "Party Wall foundation at 1.00m wide",
        sizeInMeters: 1.0,
        unit: "m",
        rate: 135.59,
      },
      {
        name: "Internal Wall foundation at 1.00m wide",
        sizeInMeters: 1.0,
        unit: "m",
        rate: 110.05,
      },
      {
        name: "Garage External Wall foundation at 1.00m wide",
        sizeInMeters: 1.0,
        unit: "m",
        rate: 101.92,
      },
      {
        name: "Garage Internal Wall foundation at 1.00m wide",
        sizeInMeters: 1.0,
        unit: "m",
        rate: 105.79,
      },
      {
        name: "External Wall foundation at 0.90m wide",
        sizeInMeters: 0.9,
        unit: "m",
        rate: 148.36,
      },
      {
        name: "Party Wall foundation at 0.90m wide",
        sizeInMeters: 0.9,
        unit: "m",
        rate: 141.52,
      },
      {
        name: "Internal Wall foundation at 0.90m wide",
        sizeInMeters: 0.9,
        unit: "m",
        rate: 109.45,
      },
      {
        name: "Garage External Wall foundation at 0.90m wide",
        sizeInMeters: 0.9,
        unit: "m",
        rate: 106.79,
      },
      {
        name: "Garage Internal Wall foundation at 0.90m wide",
        sizeInMeters: 0.9,
        unit: "m",
        rate: 102.31,
      },
      {
        name: "External Wall foundation at 0.75m wide",
        sizeInMeters: 0.75,
        unit: "m",
        rate: 141.95,
      },
      {
        name: "Party Wall foundation at 0.75m wide",
        sizeInMeters: 0.75,
        unit: "m",
        rate: 142.5,
      },
      {
        name: "Internal Wall foundation at 0.75m wide",
        sizeInMeters: 0.75,
        unit: "m",
        rate: 110.0,
      },
      {
        name: "Garage External Wall foundation at 0.75m wide",
        sizeInMeters: 0.75,
        unit: "m",
        rate: 103.43,
      },
      {
        name: "Garage Internal Wall foundation at 0.75m wide",
        sizeInMeters: 0.75,
        unit: "m",
        rate: 103.06,
      },
      {
        name: "External Wall foundation at 0.60m wide",
        sizeInMeters: 0.6,
        unit: "m",
        rate: 144.51,
      },
      {
        name: "Party Wall foundation at 0.60m wide",
        sizeInMeters: 0.6,
        unit: "m",
        rate: 144.04,
      },
      {
        name: "Internal Wall foundation at 0.60m wide",
        sizeInMeters: 0.6,
        unit: "m",
        rate: 111.83,
      },
      {
        name: "Garage External Wall foundation at 0.60m wide",
        sizeInMeters: 0.6,
        unit: "m",
        rate: 108.43,
      },
      {
        name: "Garage Internal Wall foundation at 0.60m wide",
        sizeInMeters: 0.6,
        unit: "m",
        rate: 101.27,
      },
      {
        name: "External Wall foundation at 0.45m wide",
        sizeInMeters: 0.45,
        unit: "m",
        rate: 144.89,
      },
      {
        name: "Party Wall foundation at 0.45m wide",
        sizeInMeters: 0.45,
        unit: "m",
        rate: 144.0,
      },
      {
        name: "Internal Wall foundation at 0.45m wide",
        sizeInMeters: 0.45,
        unit: "m",
        rate: 109.23,
      },
      {
        name: "Garage External Wall foundation at 0.45m wide",
        sizeInMeters: 0.45,
        unit: "m",
        rate: 107.63,
      },
      {
        name: "Garage Internal Wall foundation at 0.45m wide",
        sizeInMeters: 0.45,
        unit: "m",
        rate: 99.94,
      },
    ],
    additionalDepth: [
      { name: "Excavation", unit: "m³", rate: 15.85 },
      { name: "Concrete", unit: "m³", rate: 163.01 },
      { name: "Additional trench block", unit: "m²", rate: 94.51 },
      { name: "Additional 100mm block", unit: "m²", rate: 35.04 },
      { name: "Backfill with as dug arisings", unit: "m³", rate: 6.15 },
      { name: "Deposit surplus arisings onsite", unit: "m³", rate: 2.74 },
      { name: "Claymaster", unit: "m²", rate: 13.0 },
    ],
  },
  piledFoundations: {
    abnormals: [
      { name: "EO step at party wall", unit: "m²", rate: 45.67 },
      { name: "Exposed brickwork", unit: "m²", rate: 101.98 },
      {
        name: "Tanking (one skin blwk, one skin facings plus tanking)",
        unit: "m²",
        rate: 160.0,
      },
      { name: "EO coloured mortar", unit: "m²", rate: 5.94 },
    ],
    floors: [
      {
        name: "Longley concrete beam & polystyrene infill floor with membranes and screed",
        unit: "m²",
        rate: 97.48,
      },
      {
        name: "Garage floor (beam & infill)",
        unit: "m²",
        rate: 82.37,
      },
      {
        name: "House insitu Floor - 150mm thick",
        unit: "m²",
        rate: 85.03,
      },
      {
        name: "Garage Insitu Floor - 150mm thick",
        unit: "m²",
        rate: 52.42,
      },
    ],
  },
};

export const morrisMatrix = {
  project_info: {
    project_name: "Residential Development Plot Matrix",
    total_plots: 40,
    development_type: "Mixed Housing Development",
  },
  plots: [
    {
      plot_no: "030",
      code: "WINS_DG",
      house_type: "Winster Double Garage",
      hse_gge_car_port: "House",
      market_desc: "4 Bed Detached House",
      tenure: "Private",
      sq_ft: 1796,
      handing: "AS",
      facings_material: "Render - Ipstock Lec Weathered multi splash",
      render: "FULL",
      costs: {
        plot_strip_cut_fill: 2442.85,
        excavate_concrete: 22388.88,
        brickwork_to_dpc: 10953.48,
        foundation_oversite: 15213.02,
        foundation_abnormal: 0,
        plot_drainage: 4760.75,
        plot_services: 730.06,
        service_exposure: 542.37,
        clean_grade1: 179.43,
        clean_grade2: "incl",
        hardstanding_scaffold: 1162.6,
        driveway_to_bu: 8084.44,
        driveway_to_wc: 5292.2,
        pavings_600x600_buff: 2747.14,
        topsoil_return: 584.22,
        retaining_walls: 0,
        screen_walls: 2952.7,
        extra_over_for: "excl",
        sub_total: 78034.14,
        discount: 2292.42,
        total: 75741.72,
      },
    },
    {
      plot_no: "031",
      code: "NORF",
      house_type: "Norfolk",
      hse_gge_car_port: "House",
      market_desc: "4 Bed Detached House",
      tenure: "Private",
      sq_ft: 1502,
      handing: "OPP",
      facings_material: "Render - Ipstock Lec Weathered Multi",
      render: "PART",
      costs: {
        plot_strip_cut_fill: 1628.63,
        excavate_concrete: 17865.37,
        brickwork_to_dpc: 8762.42,
        foundation_oversite: 11548.46,
        foundation_abnormal: 0,
        plot_drainage: 4760.75,
        plot_services: 730.06,
        service_exposure: 542.37,
        clean_grade1: 179.43,
        clean_grade2: "incl",
        hardstanding_scaffold: 1033.43,
        driveway_to_bu: 5474.57,
        driveway_to_wc: 3571.9,
        pavings_600x600_buff: 1824.68,
        topsoil_return: 584.22,
        retaining_walls: 0,
        screen_walls: 940.64,
        extra_over_for: "excl",
        sub_total: 59446.97,
        discount: 1754.81,
        total: 57692.16,
      },
    },
    {
      plot_no: "032",
      code: "ABIN",
      house_type: "Abingdon",
      hse_gge_car_port: "House",
      market_desc: "4 Bed Detached House",
      tenure: "Private",
      sq_ft: 1449,
      handing: "AS",
      facings_material: "Wienerberger Yellow Multi Gft",
      render: "",
      costs: {
        plot_strip_cut_fill: 1661.13,
        excavate_concrete: 18168.02,
        brickwork_to_dpc: 8911.49,
        foundation_oversite: 10883.48,
        foundation_abnormal: 0,
        plot_drainage: 4760.75,
        plot_services: 730.06,
        service_exposure: 542.37,
        clean_grade1: 179.43,
        clean_grade2: "incl",
        hardstanding_scaffold: 960.73,
        driveway_to_bu: 5029.41,
        driveway_to_wc: 3573.96,
        pavings_600x600_buff: 1880.79,
        topsoil_return: 584.22,
        retaining_walls: 0,
        screen_walls: 1111.09,
        extra_over_for: "excl",
        sub_total: 59016.93,
        discount: 1741.71,
        total: 57275.22,
      },
    },
    {
      plot_no: "033",
      code: "NORF",
      house_type: "Norfolk",
      hse_gge_car_port: "House",
      market_desc: "4 Bed Detached House",
      tenure: "Private",
      sq_ft: 1502,
      handing: "AS",
      facings_material: "Wienerberger Yellow Multi Gft",
      render: "",
      costs: {
        plot_strip_cut_fill: 1510.62,
        excavate_concrete: 17865.37,
        brickwork_to_dpc: 8762.42,
        foundation_oversite: 11548.46,
        foundation_abnormal: 324.55,
        plot_drainage: 4760.75,
        plot_services: 730.06,
        service_exposure: 542.37,
        clean_grade1: 179.43,
        clean_grade2: "incl",
        hardstanding_scaffold: 1033.45,
        driveway_to_bu: 5426.22,
        driveway_to_wc: 3540.03,
        pavings_600x600_buff: 1526.77,
        topsoil_return: 584.22,
        retaining_walls: 0,
        screen_walls: 1022.71,
        extra_over_for: "excl",
        sub_total: 60163.43,
        discount: 1756.3,
        total: 58407.13,
      },
    },
    {
      plot_no: "034",
      code: "WINS",
      house_type: "Winster",
      hse_gge_car_port: "House",
      market_desc: "4 Bed Detached House",
      tenure: "Private",
      sq_ft: 1796,
      handing: "AS",
      facings_material: "Render - Ipstock Lec Weathered multi splash",
      render: "FULL",
      costs: {
        plot_strip_cut_fill: 2079.73,
        excavate_concrete: 16162.68,
        brickwork_to_dpc: 7923.79,
        foundation_oversite: 11510.25,
        foundation_abnormal: 0,
        plot_drainage: 4760.75,
        plot_services: 730.06,
        service_exposure: 542.37,
        clean_grade1: 179.43,
        clean_grade2: "incl",
        hardstanding_scaffold: 973.34,
        driveway_to_bu: 6273.05,
        driveway_to_wc: 4350.62,
        pavings_600x600_buff: 1837.56,
        topsoil_return: 584.22,
        retaining_walls: 0,
        screen_walls: 2481.6,
        extra_over_for: "excl",
        sub_total: 61298.45,
        discount: 1790.35,
        total: 59508.1,
      },
    },
    {
      plot_no: "034G",
      code: "DOUB_PYRA_STD",
      house_type: "Garage - Double Pyramid detached Std",
      hse_gge_car_port: "Garage",
      market_desc: "",
      tenure: "Private",
      sq_ft: null,
      handing: "AS",
      facings_material: "Render - Ipstock Lec Weathered Multi",
      render: "",
      costs: {
        plot_strip_cut_fill: 0,
        excavate_concrete: 6956.06,
        brickwork_to_dpc: 3389.18,
        foundation_oversite: 3719.76,
        foundation_abnormal: 204.92,
        plot_drainage: 0,
        plot_services: 0,
        service_exposure: 0,
        clean_grade1: 0,
        clean_grade2: 0,
        hardstanding_scaffold: 571.89,
        driveway_to_bu: 0,
        driveway_to_wc: 0,
        pavings_600x600_buff: 0,
        topsoil_return: 0,
        retaining_walls: 0,
        screen_walls: 0,
        extra_over_for: "excl",
        sub_total: 14841.81,
        discount: 396.65,
        total: 14445.16,
      },
    },
    {
      plot_no: "035",
      code: "ADLI",
      house_type: "Adlington",
      hse_gge_car_port: "House",
      market_desc: "4 Bed Detached House",
      tenure: "Private",
      sq_ft: 1119,
      handing: "AS",
      facings_material: "Render - Ipstock Lec Weathered Multi",
      render: "",
      costs: {
        plot_strip_cut_fill: 994.31,
        excavate_concrete: 15316.76,
        brickwork_to_dpc: 7507.13,
        foundation_oversite: 8302.16,
        foundation_abnormal: 0,
        plot_drainage: 4760.75,
        plot_services: 730.06,
        service_exposure: 542.37,
        clean_grade1: 179.43,
        clean_grade2: "incl",
        hardstanding_scaffold: 875.62,
        driveway_to_bu: 2177.5,
        driveway_to_wc: 798.2,
        pavings_600x600_buff: 1647.18,
        topsoil_return: 584.22,
        retaining_walls: 0,
        screen_walls: 0,
        extra_over_for: "excl",
        sub_total: 44415.69,
        discount: 1283.87,
        total: 43131.82,
      },
    },
    {
      plot_no: "036",
      code: "KNUT",
      house_type: "Knutsford",
      hse_gge_car_port: "House",
      market_desc: "3 Bed Detached House",
      tenure: "Private",
      sq_ft: 1056,
      handing: "AS",
      facings_material: "Render - Ipstock Lec Weathered Multi",
      render: "",
      costs: {
        plot_strip_cut_fill: 1101.91,
        excavate_concrete: 17371.9,
        brickwork_to_dpc: 8515.37,
        foundation_oversite: 8370.91,
        foundation_abnormal: 0,
        plot_drainage: 4760.75,
        plot_services: 730.06,
        service_exposure: 542.37,
        clean_grade1: 179.43,
        clean_grade2: "incl",
        hardstanding_scaffold: 846.03,
        driveway_to_bu: 2059.08,
        driveway_to_wc: 720.14,
        pavings_600x600_buff: 1594.76,
        topsoil_return: 584.22,
        retaining_walls: 0,
        screen_walls: 0,
        extra_over_for: "excl",
        sub_total: 47380.93,
        discount: 1372.83,
        total: 46008.1,
      },
    },
    {
      plot_no: "037",
      code: "HOUGH",
      house_type: "Houghton",
      hse_gge_car_port: "House",
      market_desc: "4 Bed Detached House",
      tenure: "Private",
      sq_ft: 1325,
      handing: "OPP",
      facings_material: "Wienerberger Yellow Multi Gft",
      render: "",
      costs: {
        plot_strip_cut_fill: 1592.29,
        excavate_concrete: 19414.18,
        brickwork_to_dpc: 9584.97,
        foundation_oversite: 7916.55,
        foundation_abnormal: 101.67,
        plot_drainage: 4760.75,
        plot_services: 730.06,
        service_exposure: 542.37,
        clean_grade1: 179.43,
        clean_grade2: "incl",
        hardstanding_scaffold: 780.85,
        driveway_to_bu: 2547.46,
        driveway_to_wc: 1042.06,
        pavings_600x600_buff: 1072.37,
        topsoil_return: 584.22,
        retaining_walls: 0,
        screen_walls: 0,
        extra_over_for: "excl",
        sub_total: 38849.46,
        discount: 1116.88,
        total: 37732.58,
      },
    },
    {
      plot_no: "037G",
      code: "GARSING_PLUS",
      house_type: "Garage - Single detached plus",
      hse_gge_car_port: "Garage",
      market_desc: "",
      tenure: "Private",
      sq_ft: null,
      handing: "AS",
      facings_material: "Wienerberger Yellow Multi Gft",
      render: "",
      costs: {
        plot_strip_cut_fill: 0,
        excavate_concrete: 4296.9,
        brickwork_to_dpc: 2079.45,
        foundation_oversite: 1823.52,
        foundation_abnormal: 2012.65,
        plot_drainage: 0,
        plot_services: 0,
        service_exposure: 0,
        clean_grade1: 0,
        clean_grade2: 0,
        hardstanding_scaffold: 427.37,
        driveway_to_bu: 0,
        driveway_to_wc: 0,
        pavings_600x600_buff: 0,
        topsoil_return: 0,
        retaining_walls: 0,
        screen_walls: 0,
        extra_over_for: "excl",
        sub_total: 10639.89,
        discount: 270.8,
        total: 10369.09,
      },
    },
  ],
  cost_categories: {
    construction: [
      "plot_strip_cut_fill",
      "excavate_concrete",
      "brickwork_to_dpc",
      "foundation_oversite",
      "foundation_abnormal",
    ],
    services: ["plot_drainage", "plot_services", "service_exposure"],
    finishing: [
      "clean_grade1",
      "clean_grade2",
      "hardstanding_scaffold",
      "driveway_to_bu",
      "driveway_to_wc",
      "pavings_600x600_buff",
      "topsoil_return",
    ],
    additional: ["retaining_walls", "screen_walls", "extra_over_for"],
  },
  house_types: [
    {
      code: "WINS_DG",
      name: "Winster Double Garage",
      bedrooms: 4,
      type: "Detached",
      typical_sq_ft: 1796,
    },
    {
      code: "NORF",
      name: "Norfolk",
      bedrooms: 4,
      type: "Detached",
      typical_sq_ft: 1502,
    },
    {
      code: "ABIN",
      name: "Abingdon",
      bedrooms: 4,
      type: "Detached",
      typical_sq_ft: 1449,
    },
    {
      code: "WINS",
      name: "Winster",
      bedrooms: 4,
      type: "Detached",
      typical_sq_ft: 1796,
    },
    {
      code: "ADLI",
      name: "Adlington",
      bedrooms: 4,
      type: "Detached",
      typical_sq_ft: 1119,
    },
    {
      code: "KNUT",
      name: "Knutsford",
      bedrooms: 3,
      type: "Detached",
      typical_sq_ft: 1056,
    },
    {
      code: "HOUGH",
      name: "Houghton",
      bedrooms: 4,
      type: "Detached",
      typical_sq_ft: 1325,
    },
  ],
  garage_types: [
    {
      code: "DOUB_PYRA_STD",
      name: "Garage - Double Pyramid detached Std",
      type: "Double Garage",
    },
    {
      code: "GARSING_PLUS",
      name: "Garage - Single detached plus",
      type: "Single Garage Plus",
    },
  ],
  material_options: {
    render_types: [
      "Render - Ipstock Lec Weathered multi splash",
      "Render - Ipstock Lec Weathered Multi",
    ],
    brick_types: ["Wienerberger Yellow Multi Gft"],
    render_coverage: ["FULL", "PART", ""],
  },
  standard_costs: {
    plot_drainage: 4760.75,
    plot_services: 730.06,
    service_exposure: 542.37,
    clean_grade1: 179.43,
    topsoil_return: 584.22,
  },
  summary: {
    total_plots: 10,
    total_sub_total: 504516.58,
    total_discount: 14572.52,
    total_final_cost: 489944.06,
    average_discount_percentage: 2.89,
    house_plots: 8,
    garage_plots: 2,
  },
};

export const morrisMatrixCompleteData = [
  {
    "PLOT NO": "030",
    CODE: "WINS_DG",
    "HOUSE TYPE": "Winster Double Garage",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1796",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - Russell Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C":
      "Render - Ibstock Leic Weathered multi splash",
    RENDER: "FULL",
    "PLOT STRIP / CUT & FILL": "2442.85",
    "EXCAVATE & CONCRETE": "22388.88",
    "BRICKWORK TO DPC": "10953.48",
    "FOUNDATION OVERSITE COMPLETE": "15213.02",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "1162.6",
    "DRIVEWAY TO BC": "8084.44",
    "DRIVEWAY TO WC": "5292.2",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "2747.14",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "2952.7",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl ",
    Ph1: "x",
    "SUB TOTAL": "78034.14",
    Discount: "-2292.42",
    TOTAL: "75741.72",
  },
  {
    "PLOT NO": "031",
    CODE: "NORF",
    "HOUSE TYPE": "Norfolk",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1502",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1628.65",
    "EXCAVATE & CONCRETE": "17865.37",
    "BRICKWORK TO DPC": "8762.42",
    "FOUNDATION OVERSITE COMPLETE": "11548.46",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "1033.45",
    "DRIVEWAY TO BC": "5474.57",
    "DRIVEWAY TO WC": "3571.9",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1824.68",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "940.64",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "59446.97",
    Discount: "-1734.81",
    TOTAL: "57712.16",
  },
  {
    "PLOT NO": "032",
    CODE: "ABIN",
    "HOUSE TYPE": "Abingdon",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1469",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1661.13",
    "EXCAVATE & CONCRETE": "18168.02",
    "BRICKWORK TO DPC": "8911.49",
    "FOUNDATION OVERSITE COMPLETE": "10883.48",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "960.73",
    "DRIVEWAY TO BC": "5629.41",
    "DRIVEWAY TO WC": "3673.96",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1880.79",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "1111.09",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "59676.93",
    Discount: "-1741.71",
    TOTAL: "57935.22",
  },
  {
    "PLOT NO": "033",
    CODE: "NORF",
    "HOUSE TYPE": "Norfolk",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1502",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1916.62",
    "EXCAVATE & CONCRETE": "17865.37",
    "BRICKWORK TO DPC": "8762.42",
    "FOUNDATION OVERSITE COMPLETE": "11548.46",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "324.55",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "1033.45",
    "DRIVEWAY TO BC": "5426.22",
    "DRIVEWAY TO WC": "3540.03",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1926.77",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "1022.71",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "60163.43",
    Discount: "-1756.3",
    TOTAL: "58407.13",
  },
  {
    "PLOT NO": "034",
    CODE: "WINS",
    "HOUSE TYPE": "Winster",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1796",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C":
      "Render - Ibstock Leic Weathered multi splash",
    RENDER: "FULL",
    "PLOT STRIP / CUT & FILL": "2079.73",
    "EXCAVATE & CONCRETE": "16162.68",
    "BRICKWORK TO DPC": "7923.79",
    "FOUNDATION OVERSITE COMPLETE": "11510.25",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "973.34",
    "DRIVEWAY TO BC": "6973.05",
    "DRIVEWAY TO WC": "4559.62",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1837.56",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "2481.6",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "61298.45",
    Discount: "-1790.35",
    TOTAL: "59508.1",
  },
  {
    "PLOT NO": "034G",
    CODE: "DOUB_PYRA_STD",
    "HOUSE TYPE": "Garage - Double  Pyramid detached Std",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "6956.06",
    "BRICKWORK TO DPC": "3389.18",
    "FOUNDATION OVERSITE COMPLETE": "3719.76",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "204.92",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "571.89",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "14841.81",
    Discount: "-396.65",
    TOTAL: "14445.16",
  },
  {
    "PLOT NO": "035",
    CODE: "ADLI",
    "HOUSE TYPE": "Adlington",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1119",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "994.31",
    "EXCAVATE & CONCRETE": "15316.76",
    "BRICKWORK TO DPC": "7507.13",
    "FOUNDATION OVERSITE COMPLETE": "8302.16",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "875.62",
    "DRIVEWAY TO BC": "2177.5",
    "DRIVEWAY TO WC": "798.2",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1647.18",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "44415.69",
    Discount: "-1283.87",
    TOTAL: "43131.82",
  },
  {
    "PLOT NO": "036",
    CODE: "KNUT",
    "HOUSE TYPE": "Knutsford",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "3 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1056",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1101.91",
    "EXCAVATE & CONCRETE": "17371.9",
    "BRICKWORK TO DPC": "8519.37",
    "FOUNDATION OVERSITE COMPLETE": "8370.91",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "846.03",
    "DRIVEWAY TO BC": "2059.08",
    "DRIVEWAY TO WC": "720.14",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1594.76",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "47380.93",
    Discount: "-1372.83",
    TOTAL: "46008.1",
  },
  {
    "PLOT NO": "037",
    CODE: "HOUG",
    "HOUSE TYPE": "Houghton",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1325",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1592.29",
    "EXCAVATE & CONCRETE": "11414.18",
    "BRICKWORK TO DPC": "5584.97",
    "FOUNDATION OVERSITE COMPLETE": "7916.55",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "101.87",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "780.88",
    "DRIVEWAY TO BC": "2547.46",
    "DRIVEWAY TO WC": "1042.06",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1072.37",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "38849.46",
    Discount: "-1116.88",
    TOTAL: "37732.58",
  },
  {
    "PLOT NO": "037G",
    CODE: "GARSING_PLUS",
    "HOUSE TYPE": "Garage - Single detached plus",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "4296.9",
    "BRICKWORK TO DPC": "2079.45",
    "FOUNDATION OVERSITE COMPLETE": "1823.52",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "2012.65",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "427.37",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "10639.89",
    Discount: "-270.6",
    TOTAL: "10369.29",
  },
  {
    "PLOT NO": "167",
    CODE: "BRAN",
    "HOUSE TYPE": "Brancaster",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1169",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "2016.01",
    "EXCAVATE & CONCRETE": "2800.02",
    "BRICKWORK TO DPC": "4446.08",
    "FOUNDATION OVERSITE COMPLETE": "6517.12",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "2388.56",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "780.65",
    "DRIVEWAY TO BC": "5443.02",
    "DRIVEWAY TO WC": "3492.17",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "776.23",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "3351.6",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "38808.29",
    Discount: "-1115.65",
    TOTAL: "37692.64",
  },
  {
    "PLOT NO": "167G",
    CODE: "GARSING_PLUS",
    "HOUSE TYPE": "Garage - Single detached plus",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "969.28",
    "BRICKWORK TO DPC": "1459.09",
    "FOUNDATION OVERSITE COMPLETE": "1712.54",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "99.13",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "423.93",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "4663.97",
    Discount: "-91.32",
    TOTAL: "4572.65",
  },
  {
    "PLOT NO": "168",
    CODE: "CRAN",
    "HOUSE TYPE": "Cranleigh",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1358",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "2037.49",
    "EXCAVATE & CONCRETE": "3349.82",
    "BRICKWORK TO DPC": "5343.14",
    "FOUNDATION OVERSITE COMPLETE": "8360.39",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "4282.85",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "859.79",
    "DRIVEWAY TO BC": "5494.13",
    "DRIVEWAY TO WC": "3525.85",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1178.14",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "935.28",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "42163.71",
    Discount: "-1216.31",
    TOTAL: "40947.4",
  },
  {
    "PLOT NO": "168G",
    CODE: "GARSING_PLUS",
    "HOUSE TYPE": "Garage - Single detached plus",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "969.28",
    "BRICKWORK TO DPC": "1459.09",
    "FOUNDATION OVERSITE COMPLETE": "1712.54",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "2283.97",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "423.93",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "6848.81",
    Discount: "-156.86",
    TOTAL: "6691.95",
  },
  {
    "PLOT NO": "169",
    CODE: "DAVE",
    "HOUSE TYPE": "Davenham",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "3 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "957",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1865.87",
    "EXCAVATE & CONCRETE": "2425.42",
    "BRICKWORK TO DPC": "3834.9",
    "FOUNDATION OVERSITE COMPLETE": "5387.16",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "2490.81",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "674.21",
    "DRIVEWAY TO BC": "5474.85",
    "DRIVEWAY TO WC": "3513.15",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1188.25",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "410.35",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "34061.8",
    Discount: "-973.25",
    TOTAL: "33088.55",
  },
  {
    "PLOT NO": "169G",
    CODE: "GARSING_PLUS",
    "HOUSE TYPE": "Garage - Single detached plus",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "969.28",
    "BRICKWORK TO DPC": "1459.09",
    "FOUNDATION OVERSITE COMPLETE": "1712.54",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "1516.45",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "423.93",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "6081.29",
    Discount: "-133.84",
    TOTAL: "5947.45",
  },
  {
    "PLOT NO": "170",
    CODE: "HENL",
    "HOUSE TYPE": "Henley",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1462",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "PART",
    "PLOT STRIP / CUT & FILL": "1764.78",
    "EXCAVATE & CONCRETE": "13409.43",
    "BRICKWORK TO DPC": "6567.7",
    "FOUNDATION OVERSITE COMPLETE": "8677.42",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "374.31",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "832.26",
    "DRIVEWAY TO BC": "5372.34",
    "DRIVEWAY TO WC": "3445.58",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1893.66",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "631.3",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "49765.61",
    Discount: "-1444.37",
    TOTAL: "48321.24",
  },
  {
    "PLOT NO": "170G",
    CODE: "DOUB_PYRA_STD",
    "HOUSE TYPE": "Garage - Double  Pyramid detached Std",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "1422.41",
    "BRICKWORK TO DPC": "2198.4",
    "FOUNDATION OVERSITE COMPLETE": "2857.74",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "573.72",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "514.54",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "7566.81",
    Discount: "-178.4",
    TOTAL: "7388.41",
  },
  {
    "PLOT NO": "171",
    CODE: "CAMB_E",
    "HOUSE TYPE": "Camberley  End",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "2 Bed End Mews House",
    TENURE: "Private",
    "SQ FT": "753",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1755.95",
    "EXCAVATE & CONCRETE": "9155.05",
    "BRICKWORK TO DPC": "4472.27",
    "FOUNDATION OVERSITE COMPLETE": "6871.5",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "564.32",
    "DRIVEWAY TO BC": "4943.83",
    "DRIVEWAY TO WC": "3192.23",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1503.71",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "39255.69",
    Discount: "-1129.07",
    TOTAL: "38126.62",
  },
  {
    "PLOT NO": "172",
    CODE: "CAMB_E",
    "HOUSE TYPE": "Camberley  End",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "2 Bed End Mews House",
    TENURE: "Private",
    "SQ FT": "753",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1734.51",
    "EXCAVATE & CONCRETE": "9224.12",
    "BRICKWORK TO DPC": "4506.29",
    "FOUNDATION OVERSITE COMPLETE": "6871.5",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "564.32",
    "DRIVEWAY TO BC": "4809.81",
    "DRIVEWAY TO WC": "3103.89",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1580.96",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "39192.23",
    Discount: "-1127.17",
    TOTAL: "38065.06",
  },
  {
    "PLOT NO": "173",
    CODE: "CAPE_E",
    "HOUSE TYPE": "Capesthorpe End",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "3 Bed Semi-Detached House",
    TENURE: "Private",
    "SQ FT": "947",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "2400.67",
    "EXCAVATE & CONCRETE": "9025.54",
    "BRICKWORK TO DPC": "4408.48",
    "FOUNDATION OVERSITE COMPLETE": "5794.75",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "284.27",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "499.63",
    "DRIVEWAY TO BC": "5647.63",
    "DRIVEWAY TO WC": "3656.14",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1938.73",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "2892.7",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "43345.37",
    Discount: "-1251.76",
    TOTAL: "42093.61",
  },
  {
    "PLOT NO": "174",
    CODE: "DISL_E",
    "HOUSE TYPE": "Disley End",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "3 Bed Semi-Detached House",
    TENURE: "Private",
    "SQ FT": "934",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1143.42",
    "EXCAVATE & CONCRETE": "8380.64",
    "BRICKWORK TO DPC": "4090.84",
    "FOUNDATION OVERSITE COMPLETE": "5656.63",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "389.7",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "459.49",
    "DRIVEWAY TO BC": "2313.98",
    "DRIVEWAY TO WC": "888.16",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1515.67",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "4552.85",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "36188.21",
    Discount: "-1037.05",
    TOTAL: "35151.16",
  },
  {
    "PLOT NO": "174G",
    CODE: "DOUB_PYRA_PLUS",
    "HOUSE TYPE": "Garage - Double  Pyramid detached plus",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "6956.06",
    "BRICKWORK TO DPC": "3389.18",
    "FOUNDATION OVERSITE COMPLETE": "3719.76",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "2479.11",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "571.89",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "17116",
    Discount: "-464.88",
    TOTAL: "16651.12",
  },
  {
    "PLOT NO": "175",
    CODE: "DIDS",
    "HOUSE TYPE": "Didsbury",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "3 Bed Semi-Detached House",
    TENURE: "Private",
    "SQ FT": "874",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "996.93",
    "EXCAVATE & CONCRETE": "8062.39",
    "BRICKWORK TO DPC": "3934.09",
    "FOUNDATION OVERSITE COMPLETE": "5336.19",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "459.72",
    "DRIVEWAY TO BC": "2313.98",
    "DRIVEWAY TO WC": "888.16",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1224.12",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "30012.41",
    Discount: "-851.77",
    TOTAL: "29160.64",
  },
  {
    "PLOT NO": "176",
    CODE: "DIDS",
    "HOUSE TYPE": "Didsbury",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "3 Bed Semi-Detached House",
    TENURE: "Private",
    "SQ FT": "874",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1111.51",
    "EXCAVATE & CONCRETE": "8062.39",
    "BRICKWORK TO DPC": "3934.09",
    "FOUNDATION OVERSITE COMPLETE": "5336.19",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "459.72",
    "DRIVEWAY TO BC": "2424.75",
    "DRIVEWAY TO WC": "961.17",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "921.54",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "397.72",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "30405.91",
    Discount: "-863.58",
    TOTAL: "29542.33",
  },
  {
    "PLOT NO": "176G",
    CODE: "GARSING_PLUS",
    "HOUSE TYPE": "Garage - Single detached plus",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "4296.9",
    "BRICKWORK TO DPC": "2079.45",
    "FOUNDATION OVERSITE COMPLETE": "1823.52",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "904.44",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "427.37",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "9531.68",
    Discount: "-237.35",
    TOTAL: "9294.33",
  },
  {
    "PLOT NO": "177",
    CODE: "PATT_E",
    "HOUSE TYPE": "Patterdale End",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "2 Bed End Mews House",
    TENURE: "HA - Rent",
    "SQ FT": "825",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1081.29",
    "EXCAVATE & CONCRETE": "6467.78",
    "BRICKWORK TO DPC": "3148.69",
    "FOUNDATION OVERSITE COMPLETE": "5024.83",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "433.8",
    "DRIVEWAY TO BC": "2065.81",
    "DRIVEWAY TO WC": "724.58",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1049.38",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "2535.08",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "29328.07",
    Discount: "-831.24",
    TOTAL: "28496.83",
  },
  {
    "PLOT NO": "178",
    CODE: "PATT_M",
    "HOUSE TYPE": "Patterdale Mid",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "2 Bed Mid Mews House",
    TENURE: "HA - Rent",
    "SQ FT": "825",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1372.82",
    "EXCAVATE & CONCRETE": "5301.84",
    "BRICKWORK TO DPC": "2574.42",
    "FOUNDATION OVERSITE COMPLETE": "5024.83",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "232.84",
    "DRIVEWAY TO BC": "2477.08",
    "DRIVEWAY TO WC": "995.66",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "2865.79",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "2445.21",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "30087.32",
    Discount: "-854.02",
    TOTAL: "29233.3",
  },
  {
    "PLOT NO": "179",
    CODE: "ESKD",
    "HOUSE TYPE": "ESKDALE",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "2 Bed End Mews House",
    TENURE: "HA - Rent",
    "SQ FT": "843",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1391.62",
    "EXCAVATE & CONCRETE": "7184.96",
    "BRICKWORK TO DPC": "3501.92",
    "FOUNDATION OVERSITE COMPLETE": "5276.2",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "475.32",
    "DRIVEWAY TO BC": "2477.08",
    "DRIVEWAY TO WC": "995.66",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "855.32",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "6359.01",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "35313.92",
    Discount: "-1010.82",
    TOTAL: "34303.1",
  },
  {
    "PLOT NO": "180",
    CODE: "PATT_E",
    "HOUSE TYPE": "Patterdale End",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "2 Bed End Mews House",
    TENURE: "HA - Rent",
    "SQ FT": "825",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "3903.28",
    "EXCAVATE & CONCRETE": "6574.68",
    "BRICKWORK TO DPC": "3201.34",
    "FOUNDATION OVERSITE COMPLETE": "5024.83",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "434.02",
    "DRIVEWAY TO BC": "3975.57",
    "DRIVEWAY TO WC": "2345.91",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "1297.7",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "33554.16",
    Discount: "-958.02",
    TOTAL: "32596.14",
  },
  {
    "PLOT NO": "181",
    CODE: "PATT_E",
    "HOUSE TYPE": "Patterdale End",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "2 Bed End Mews House",
    TENURE: "HA - Rent",
    "SQ FT": "825",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "3476.14",
    "EXCAVATE & CONCRETE": "6505.62",
    "BRICKWORK TO DPC": "3167.32",
    "FOUNDATION OVERSITE COMPLETE": "5024.83",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "434.02",
    "DRIVEWAY TO BC": "3975.57",
    "DRIVEWAY TO WC": "2345.91",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "622.64",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "32348.88",
    Discount: "-921.87",
    TOTAL: "31427.01",
  },
  {
    "PLOT NO": "182",
    CODE: "PATT_E",
    "HOUSE TYPE": "Patterdale End",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "2 Bed End Mews House",
    TENURE: "HA - Rent",
    "SQ FT": "825",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "3189.15",
    "EXCAVATE & CONCRETE": "6409.61",
    "BRICKWORK TO DPC": "3120.03",
    "FOUNDATION OVERSITE COMPLETE": "5024.83",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "433.34",
    "DRIVEWAY TO BC": "3980.47",
    "DRIVEWAY TO WC": "2349.14",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "2841.87",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "34145.27",
    Discount: "-975.76",
    TOTAL: "33169.51",
  },
  {
    "PLOT NO": "183",
    CODE: "PATT_M",
    "HOUSE TYPE": "Patterdale Mid",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "2 Bed Mid Mews House",
    TENURE: "HA - Rent",
    "SQ FT": "825",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "3189.15",
    "EXCAVATE & CONCRETE": "5165.3",
    "BRICKWORK TO DPC": "2507.17",
    "FOUNDATION OVERSITE COMPLETE": "5024.83",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "232.61",
    "DRIVEWAY TO BC": "3980.47",
    "DRIVEWAY TO WC": "2349.14",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "2841.87",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "32087.37",
    Discount: "-914.02",
    TOTAL: "31173.35",
  },
  {
    "PLOT NO": "184",
    CODE: "PATT_E",
    "HOUSE TYPE": "Patterdale End",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "2 Bed End Mews House",
    TENURE: "HA - Rent",
    "SQ FT": "825",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "3079.04",
    "EXCAVATE & CONCRETE": "6409.61",
    "BRICKWORK TO DPC": "3120.03",
    "FOUNDATION OVERSITE COMPLETE": "5024.83",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "433.34",
    "DRIVEWAY TO BC": "3980.47",
    "DRIVEWAY TO WC": "2349.14",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "2034.38",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "33227.67",
    Discount: "-948.23",
    TOTAL: "32279.44",
  },
  {
    "PLOT NO": "185",
    CODE: "BUX_E",
    "HOUSE TYPE": "Buxton End",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "3 Bed End Mews",
    TENURE: "HA - Rent",
    "SQ FT": "963",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "2849.66",
    "EXCAVATE & CONCRETE": "7473.12",
    "BRICKWORK TO DPC": "3643.85",
    "FOUNDATION OVERSITE COMPLETE": "5790.23",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "464.76",
    "DRIVEWAY TO BC": "3980.47",
    "DRIVEWAY TO WC": "2349.14",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "2034.38",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "35382.44",
    Discount: "-1012.87",
    TOTAL: "34369.57",
  },
  {
    "PLOT NO": "186",
    CODE: "WIND",
    "HOUSE TYPE": "Windermere",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "1 Bed Apartment",
    TENURE: "HA - Rent",
    "SQ FT": "543",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "2063.5",
    "EXCAVATE & CONCRETE": "5123.05",
    "BRICKWORK TO DPC": "2486.35",
    "FOUNDATION OVERSITE COMPLETE": "3381.41",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "362.22",
    "DRIVEWAY TO BC": "3683.04",
    "DRIVEWAY TO WC": "2153.08",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1259.99",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "27309.47",
    Discount: "-770.68",
    TOTAL: "26538.79",
  },
  {
    "PLOT NO": "187",
    CODE: "WIND",
    "HOUSE TYPE": "Windermere",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "1 Bed Apartment",
    TENURE: "HA - Rent",
    "SQ FT": "543",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "2063.5",
    "EXCAVATE & CONCRETE": "5123.05",
    "BRICKWORK TO DPC": "2486.35",
    "FOUNDATION OVERSITE COMPLETE": "3381.41",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "362.22",
    "DRIVEWAY TO BC": "3683.04",
    "DRIVEWAY TO WC": "2153.08",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1259.99",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "27309.47",
    Discount: "-770.68",
    TOTAL: "26538.79",
  },
  {
    "PLOT NO": "188",
    CODE: "WIND",
    "HOUSE TYPE": "Windermere",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "1 Bed Apartment",
    TENURE: "HA - Rent",
    "SQ FT": "543",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1742.32",
    "EXCAVATE & CONCRETE": "4446.01",
    "BRICKWORK TO DPC": "2152.88",
    "FOUNDATION OVERSITE COMPLETE": "3405.18",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "260.25",
    "DRIVEWAY TO BC": "3683.04",
    "DRIVEWAY TO WC": "2153.08",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "248.32",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "24887.91",
    Discount: "-698.04",
    TOTAL: "24189.87",
  },
  {
    "PLOT NO": "188b",
    CODE: "WIND_BLK",
    "HOUSE TYPE": "Windermere Grassmere Ambleside Block",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "Block / shGLl",
    TENURE: "HA - Rent",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "",
    "BRICKWORK TO DPC": "0",
    "FOUNDATION OVERSITE COMPLETE": "0",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "0",
    Discount: "48.6",
    TOTAL: "48.6",
  },
  {
    "PLOT NO": "189",
    CODE: "WIND",
    "HOUSE TYPE": "Windermere",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "1 Bed Apartment",
    TENURE: "HA - Rent",
    "SQ FT": "543",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1742.32",
    "EXCAVATE & CONCRETE": "4446.01",
    "BRICKWORK TO DPC": "2152.88",
    "FOUNDATION OVERSITE COMPLETE": "3405.18",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "260.25",
    "DRIVEWAY TO BC": "3683.04",
    "DRIVEWAY TO WC": "2153.08",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "248.32",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "24887.91",
    Discount: "-698.04",
    TOTAL: "24189.87",
  },
  {
    "PLOT NO": "190",
    CODE: "AMBL",
    "HOUSE TYPE": "Ambleside",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "1 Bed Apartment",
    TENURE: "HA - Rent",
    "SQ FT": "605",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1784.22",
    "EXCAVATE & CONCRETE": "4756.26",
    "BRICKWORK TO DPC": "2305.7",
    "FOUNDATION OVERSITE COMPLETE": "3378.01",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "250.62",
    "DRIVEWAY TO BC": "3683.04",
    "DRIVEWAY TO WC": "2153.08",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "311.78",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "25419.54",
    Discount: "-713.99",
    TOTAL: "24705.55",
  },
  {
    "PLOT NO": "191",
    CODE: "GRAS",
    "HOUSE TYPE": "Grasmere",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "1 Bed Apartment",
    TENURE: "HA - Rent",
    "SQ FT": "504",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1784.22",
    "EXCAVATE & CONCRETE": "4756.26",
    "BRICKWORK TO DPC": "2305.7",
    "FOUNDATION OVERSITE COMPLETE": "3378.01",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "250.62",
    "DRIVEWAY TO BC": "3683.04",
    "DRIVEWAY TO WC": "2153.08",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "311.78",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "25419.54",
    Discount: "-713.99",
    TOTAL: "24705.55",
  },
  {
    "PLOT NO": "192",
    CODE: "MORE",
    "HOUSE TYPE": "Moreton",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1326",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1736.02",
    "EXCAVATE & CONCRETE": "2770.42",
    "BRICKWORK TO DPC": "4397.8",
    "FOUNDATION OVERSITE COMPLETE": "7330.06",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "4168.6",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "766.2",
    "DRIVEWAY TO BC": "2181.18",
    "DRIVEWAY TO WC": "800.62",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "2144.74",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "807.2",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "33899.67",
    Discount: "-968.39",
    TOTAL: "32931.28",
  },
  {
    "PLOT NO": "192G",
    CODE: "GARSING_PLUS",
    "HOUSE TYPE": "Garage - Single detached plus",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "971.81",
    "BRICKWORK TO DPC": "1463.22",
    "FOUNDATION OVERSITE COMPLETE": "1712.54",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "1345.71",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "423.93",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "5917.21",
    Discount: "-128.92",
    TOTAL: "5788.29",
  },
  {
    "PLOT NO": "193",
    CODE: "DAVE",
    "HOUSE TYPE": "Davenham",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "3 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "957",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1992.1",
    "EXCAVATE & CONCRETE": "2367.33",
    "BRICKWORK TO DPC": "3740.11",
    "FOUNDATION OVERSITE COMPLETE": "5387.16",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "8821.41",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "674.21",
    "DRIVEWAY TO BC": "2322.55",
    "DRIVEWAY TO WC": "893.81",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1317.93",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "34313.44",
    Discount: "-980.8",
    TOTAL: "33332.64",
  },
  {
    "PLOT NO": "193G",
    CODE: "GARSING_PLUS",
    "HOUSE TYPE": "Garage - Single detached plus",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "969.28",
    "BRICKWORK TO DPC": "1459.09",
    "FOUNDATION OVERSITE COMPLETE": "1712.54",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "3213.9",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "423.93",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "7778.74",
    Discount: "-184.76",
    TOTAL: "7593.98",
  },
  {
    "PLOT NO": "194",
    CODE: "KNUT",
    "HOUSE TYPE": "Knutsford",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "3 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1056",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "2162.44",
    "EXCAVATE & CONCRETE": "3612.72",
    "BRICKWORK TO DPC": "5772.07",
    "FOUNDATION OVERSITE COMPLETE": "7567",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "14923.43",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "839.37",
    "DRIVEWAY TO BC": "1970.04",
    "DRIVEWAY TO WC": "661.45",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1898.26",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "46203.61",
    Discount: "-1337.51",
    TOTAL: "44866.1",
  },
  {
    "PLOT NO": "195",
    CODE: "KNUT",
    "HOUSE TYPE": "Knutsford",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "3 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1056",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "2899.79",
    "EXCAVATE & CONCRETE": "3612.72",
    "BRICKWORK TO DPC": "5772.07",
    "FOUNDATION OVERSITE COMPLETE": "7567",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "16642.75",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "839.37",
    "DRIVEWAY TO BC": "3518.75",
    "DRIVEWAY TO WC": "1966.91",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1984.71",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "51600.9",
    Discount: "-1499.43",
    TOTAL: "50101.47",
  },
  {
    "PLOT NO": "196",
    CODE: "DALT_D",
    "HOUSE TYPE": "Dalton Detached",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "3 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "938",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "3196.46",
    "EXCAVATE & CONCRETE": "10503.51",
    "BRICKWORK TO DPC": "5136.43",
    "FOUNDATION OVERSITE COMPLETE": "5729.08",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "694.62",
    "DRIVEWAY TO BC": "3659.21",
    "DRIVEWAY TO WC": "2059.49",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "4394.33",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "42169.96",
    Discount: "-1216.5",
    TOTAL: "40953.46",
  },
  {
    "PLOT NO": "196G",
    CODE: "GARSING_PLUS",
    "HOUSE TYPE": "Garage - Single detached plus",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "4296.9",
    "BRICKWORK TO DPC": "2079.45",
    "FOUNDATION OVERSITE COMPLETE": "1823.52",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "197.82",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "427.37",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "8825.06",
    Discount: "-216.15",
    TOTAL: "8608.91",
  },
  {
    "PLOT NO": "197",
    CODE: "CRAN",
    "HOUSE TYPE": "Cranleigh",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1358",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "3149.72",
    "EXCAVATE & CONCRETE": "14281.93",
    "BRICKWORK TO DPC": "6997.44",
    "FOUNDATION OVERSITE COMPLETE": "9206.17",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "847.63",
    "DRIVEWAY TO BC": "4126.47",
    "DRIVEWAY TO WC": "2367.48",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1429.21",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "49202.88",
    Discount: "-1427.49",
    TOTAL: "47775.39",
  },
  {
    "PLOT NO": "197G",
    CODE: "DOUB_PYRA_PLUS",
    "HOUSE TYPE": "Garage - Double  Pyramid detached plus",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "6956.06",
    "BRICKWORK TO DPC": "3389.18",
    "FOUNDATION OVERSITE COMPLETE": "3719.76",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "204.92",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "571.89",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "14841.81",
    Discount: "-396.65",
    TOTAL: "14445.16",
  },
  {
    "PLOT NO": "198",
    CODE: "WARW",
    "HOUSE TYPE": "Warwick",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1424",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "3283.14",
    "EXCAVATE & CONCRETE": "15525.86",
    "BRICKWORK TO DPC": "7363.89",
    "FOUNDATION OVERSITE COMPLETE": "9222.02",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "279.54",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "894.66",
    "DRIVEWAY TO BC": "4126.47",
    "DRIVEWAY TO WC": "2367.48",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1876.19",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "1558.8",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "2427.7",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "55722.58",
    Discount: "-1623.08",
    TOTAL: "54099.5",
  },
  {
    "PLOT NO": "199",
    CODE: "HENL",
    "HOUSE TYPE": "Henley",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1462",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "PART",
    "PLOT STRIP / CUT & FILL": "4529.82",
    "EXCAVATE & CONCRETE": "13909.43",
    "BRICKWORK TO DPC": "6567.7",
    "FOUNDATION OVERSITE COMPLETE": "8677.42",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "832.26",
    "DRIVEWAY TO BC": "5435.84",
    "DRIVEWAY TO WC": "3230.56",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "3137.1",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "44396.5",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "97513.46",
    Discount: "-2876.8",
    TOTAL: "94636.66",
  },
  {
    "PLOT NO": "199G",
    CODE: "DOUB_PYRA_STD",
    "HOUSE TYPE": "Garage - Double  Pyramid detached Std",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "6956.06",
    "BRICKWORK TO DPC": "3389.18",
    "FOUNDATION OVERSITE COMPLETE": "3719.76",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "571.89",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "14636.89",
    Discount: "-390.51",
    TOTAL: "14246.38",
  },
  {
    "PLOT NO": "200",
    CODE: "MORE",
    "HOUSE TYPE": "Moreton",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1326",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "4085.59",
    "EXCAVATE & CONCRETE": "11428.14",
    "BRICKWORK TO DPC": "5591.85",
    "FOUNDATION OVERSITE COMPLETE": "7916.55",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "90.02",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "781.34",
    "DRIVEWAY TO BC": "5435.84",
    "DRIVEWAY TO WC": "3230.56",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1978.27",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "47334.99",
    Discount: "-1371.45",
    TOTAL: "45963.54",
  },
  {
    "PLOT NO": "200G",
    CODE: "GARSING_PLUS",
    "HOUSE TYPE": "Garage - Single detached plus",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "4296.9",
    "BRICKWORK TO DPC": "2079.45",
    "FOUNDATION OVERSITE COMPLETE": "1823.52",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "427.37",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "8627.24",
    Discount: "-210.22",
    TOTAL: "8417.02",
  },
  {
    "PLOT NO": "201",
    CODE: "NORF",
    "HOUSE TYPE": "Norfolk",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1502",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "3409.68",
    "EXCAVATE & CONCRETE": "18365.37",
    "BRICKWORK TO DPC": "8762.42",
    "FOUNDATION OVERSITE COMPLETE": "11548.46",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "1033.45",
    "DRIVEWAY TO BC": "3901.81",
    "DRIVEWAY TO WC": "1934.78",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1995.75",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "57748.55",
    Discount: "-1683.86",
    TOTAL: "56064.69",
  },
  {
    "PLOT NO": "202",
    CODE: "ABIN",
    "HOUSE TYPE": "Abingdon",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1469",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "2356.02",
    "EXCAVATE & CONCRETE": "18168.02",
    "BRICKWORK TO DPC": "8911.49",
    "FOUNDATION OVERSITE COMPLETE": "10883.48",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "960.73",
    "DRIVEWAY TO BC": "2223.1",
    "DRIVEWAY TO WC": "828.25",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1872.51",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "41272.33",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "94272.76",
    Discount: "-2779.58",
    TOTAL: "91493.18",
  },
  {
    "PLOT NO": "203",
    CODE: "ADLI",
    "HOUSE TYPE": "Adlington",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1119",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "2056.1",
    "EXCAVATE & CONCRETE": "3699.86",
    "BRICKWORK TO DPC": "5914.25",
    "FOUNDATION OVERSITE COMPLETE": "7759.98",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "7271.6",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "873.78",
    "DRIVEWAY TO BC": "4207.92",
    "DRIVEWAY TO WC": "2526.9",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1970.92",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "43078.14",
    Discount: "-1243.74",
    TOTAL: "41834.4",
  },
  {
    "PLOT NO": "204",
    CODE: "KNUT",
    "HOUSE TYPE": "Knutsford",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "3 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1056",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "2382.09",
    "EXCAVATE & CONCRETE": "3659.27",
    "BRICKWORK TO DPC": "5848.01",
    "FOUNDATION OVERSITE COMPLETE": "7567",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "8311.72",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "839.37",
    "DRIVEWAY TO BC": "4146.41",
    "DRIVEWAY TO WC": "2486.35",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1828.36",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "43865.41",
    Discount: "-1267.36",
    TOTAL: "42598.05",
  },
  {
    "PLOT NO": "205",
    CODE: "WINS_DG",
    "HOUSE TYPE": "Winster Double Garage",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1796",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C":
      "Render - Ibstock Leic Weathered multi splash",
    RENDER: "FULL",
    "PLOT STRIP / CUT & FILL": "3130.97",
    "EXCAVATE & CONCRETE": "5282.91",
    "BRICKWORK TO DPC": "8374.74",
    "FOUNDATION OVERSITE COMPLETE": "13636.58",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "14748.03",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "1369.06",
    "DRIVEWAY TO BC": "4665.69",
    "DRIVEWAY TO WC": "2828.64",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "2085.88",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "2997.7",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "65917.03",
    Discount: "-1928.91",
    TOTAL: "63988.12",
  },
  {
    "PLOT NO": "206",
    CODE: "ADLI",
    "HOUSE TYPE": "Adlington",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1119",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1698.28",
    "EXCAVATE & CONCRETE": "3647.44",
    "BRICKWORK TO DPC": "5828.73",
    "FOUNDATION OVERSITE COMPLETE": "7759.98",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "2371.3",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "873.78",
    "DRIVEWAY TO BC": "2087.85",
    "DRIVEWAY TO WC": "739.1",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1930.19",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "33733.48",
    Discount: "-963.4",
    TOTAL: "32770.08",
  },
  {
    "PLOT NO": "207",
    CODE: "HOUG",
    "HOUSE TYPE": "Houghton",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1325",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "OPP",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "1767.45",
    "EXCAVATE & CONCRETE": "2774.03",
    "BRICKWORK TO DPC": "4403.69",
    "FOUNDATION OVERSITE COMPLETE": "7331.19",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "1911.35",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "767.57",
    "DRIVEWAY TO BC": "2147.52",
    "DRIVEWAY TO WC": "778.43",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "2320.4",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "738.62",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "3633.8",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "35370.88",
    Discount: "-1012.53",
    TOTAL: "34358.35",
  },
  {
    "PLOT NO": "207G",
    CODE: "DOUB_PYRA_PLUS",
    "HOUSE TYPE": "Garage - Double  Pyramid detached plus",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "1446.56",
    "BRICKWORK TO DPC": "2237.81",
    "FOUNDATION OVERSITE COMPLETE": "2857.74",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "1443.88",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "514.54",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "8500.53",
    Discount: "-206.42",
    TOTAL: "8294.11",
  },
  {
    "PLOT NO": "208",
    CODE: "BRAN",
    "HOUSE TYPE": "Brancaster",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1169",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Wienerberger Yellow Multi Gilt ",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "2241.76",
    "EXCAVATE & CONCRETE": "2733.12",
    "BRICKWORK TO DPC": "4336.92",
    "FOUNDATION OVERSITE COMPLETE": "6517.12",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "2681.23",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "780.65",
    "DRIVEWAY TO BC": "4641.84",
    "DRIVEWAY TO WC": "2885.36",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "2152.27",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "3117.7",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "38884.8",
    Discount: "-1117.94",
    TOTAL: "37766.86",
  },
  {
    "PLOT NO": "209",
    CODE: "WARW",
    "HOUSE TYPE": "Warwick",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1424",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "2151.68",
    "EXCAVATE & CONCRETE": "3560.64",
    "BRICKWORK TO DPC": "5687.09",
    "FOUNDATION OVERSITE COMPLETE": "8548.34",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "3127.77",

    "PLOT DRAINAGE": "4760.75",
    "PLOT SERVICES": "730.06",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.43",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "877.68",
    "DRIVEWAY TO BC": "4862.16",
    "DRIVEWAY TO WC": "3030.59",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1465.26",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "0",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "40108.04",
    Discount: "-1154.64",
    TOTAL: "38953.4",
  },
  {
    "PLOT NO": "209G",
    CODE: "GARSING_PLUS",
    "HOUSE TYPE": "Garage - Single detached plus",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "971.81",
    "BRICKWORK TO DPC": "1463.22",
    "FOUNDATION OVERSITE COMPLETE": "3719.76",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "1656.91",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "423.93",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "0",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "8235.63",
    Discount: "-198.47",
    TOTAL: "8037.16",
  },
  {
    "PLOT NO": "210",
    CODE: "OXFO",
    "HOUSE TYPE": "Oxford",
    "HSE / GGE / CAR PORT / REFUSE": "House",
    "MARKET DESC": "4 Bed Detached House",
    TENURE: "Private",
    "SQ FT": "1498",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "PART",
    "PLOT STRIP / CUT & FILL": "1829.52",
    "EXCAVATE & CONCRETE": "15907.17",
    "BRICKWORK TO DPC": "7551.67",
    "FOUNDATION OVERSITE COMPLETE": "8877.82",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "4760.53",
    "PLOT SERVICES": "730.08",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "542.37",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "179.53",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "incl",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "858.19",
    "DRIVEWAY TO BC": "4571.46",
    "DRIVEWAY TO WC": "2815.36",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS":
      "1815.67",
    "TOPSOIL RETURN FRONT AND REAR": "584.22",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "0",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "4282.11",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "excl",
    Ph1: "x",
    "SUB TOTAL": "55305.7",
    Discount: "-1610.57",
    TOTAL: "53695.13",
  },
  {
    "PLOT NO": "210G",
    CODE: "DOUB_PYRA_STD",
    "HOUSE TYPE": "Garage - Double  Pyramid detached Std",
    "HSE / GGE / CAR PORT / REFUSE": "Garage",
    "MARKET DESC": "",
    TENURE: "Private",
    "SQ FT": "",
    "TILE TYPE AS MATERIAL LAYOUT REVISION C":
      "SG - RussGLl Grampian Slate Grey",
    HANDING: "AS",
    "FACINGS AS MATERIAL LAYOUT REV C": "Ibstock Leicester Weathered Multi",
    RENDER: "",
    "PLOT STRIP / CUT & FILL": "",
    "EXCAVATE & CONCRETE": "6785.97",
    "BRICKWORK TO DPC": "3305.4",
    "FOUNDATION OVERSITE COMPLETE": "3489.18",
    "FOUNDATION ABNORMAL - EXTRA-OVER DEPTH / HEAVE PRECAUTIONS / EXPOSED BRICKWORK / TANKING / ETC":
      "0",

    "PLOT DRAINAGE": "",
    "PLOT SERVICES": "",
    "SERVICE EXPOSURES AND BACKFILL FOR UTILITIES": "",
    "CLEAN & GRADE 1 - HOUSE COMPLETED TO ROOF": "",
    "CLEAN & GRADE 2 - PRIOR TO TOPSOIL AND TURF": "",
    "HARDSTANDING SCAFFOLD/ FORKLIFT": "555.79",
    "DRIVEWAY TO BC": "",
    "DRIVEWAY TO WC": "",
    "PAVINGS (600 X 600 BUFF) /  GRAVEL (GOLD COAST) / PART M ACCESS": "",
    "TOPSOIL RETURN FRONT AND REAR": "",
    "RETAINING WALLS COMPLETE (LAY ONLY FACINGS) / SOE / (GRAVEL BOARDS BY OTHERS)":
      "",
    "SCREEN WALLS TO DPC (LAY ONLY FACINGS)": "",
    "EXTRA-OVER FOR SURPLUS ARISING OFF SITE TO TIP": "",
    Ph1: "x",
    "SUB TOTAL": "14136.34",
    Discount: "-375.49",
    TOTAL: "13760.85",
  },
];

export const billOfQuantities = [
  {
    "": "A",
    Description: "FOUNDATIONS & FLOORS",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    "": "1.0",
    Description: "Trenchfill Foundations",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description: "Standard 1175mm from FFL (500mm concrete; 675mm masonry).  ",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description:
      "Allowance for additional depths to the formation levels shown on the Foundation Schedule Drawing P10298-01 Rev B.",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "",
  },
  {
    "": "1.1",
    Description: "B&B Foundations",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "",
  },
  {
    Description: "External Wall 600mm wide foundation",
    Qty: "218",
    Unit: "m",
    Rate: "144.75",
    Nett: "£31,555.50",
    "OH&P": "£4,733.32",
    Total: "£36,288.82",
  },
  {
    Description: "Party Wall 600mm wide foundation",
    Qty: "15",
    Unit: "m",
    Rate: "143.65",
    Nett: "£2,154.75",
    "OH&P": "£323.21",
    Total: "£2,477.96",
  },
  {
    Description: "Internal Wall 450mm wide foundation",
    Qty: "98",
    Unit: "m",
    Rate: "108.63",
    Nett: "£10,645.74",
    "OH&P": "£1,596.86",
    Total: "£12,242.60",
  },
  {
    Description: "Garage External Wall 450mm wide foundation",
    Qty: "77",
    Unit: "m",
    Rate: "109.95",
    Nett: "£8,466.15",
    "OH&P": "£1,269.92",
    Total: "£9,736.07",
  },
  {
    Description: "Garage Internal Wall 450mm wide foundation",
    Qty: "11",
    Unit: "m",
    Rate: "108.63",
    Nett: "£1,194.93",
    "OH&P": "£179.24",
    Total: "£1,374.17",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    "": "1.2",
    Description: "Insitu Foundations",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description: "External Wall 600mm wide foundation",
    Qty: "280",
    Unit: "m",
    Rate: "136.44",
    Nett: "£38,203.20",
    "OH&P": "£5,730.48",
    Total: "£43,933.68",
  },
  {
    Description: "Party Wall 600mm wide foundation",
    Qty: "24",
    Unit: "m",
    Rate: "146.79",
    Nett: "£3,522.96",
    "OH&P": "£528.44",
    Total: "£4,051.40",
  },
  {
    Description: "Internal Wall 450mm wide foundation",
    Qty: "115",
    Unit: "m",
    Rate: "120.05",
    Nett: "£13,805.75",
    "OH&P": "£2,070.86",
    Total: "£15,876.61",
  },
  {
    Description: "Garage External Wall 450mm wide foundation",
    Qty: "96",
    Unit: "m",
    Rate: "109.64",
    Nett: "£10,525.44",
    "OH&P": "£1,578.82",
    Total: "£12,104.26",
  },
  {
    Description: "Garage Internal Wall 450mm wide foundation",
    Qty: "5",
    Unit: "m",
    Rate: "120.05",
    Nett: "£600.25",
    "OH&P": "£90.04",
    Total: "£690.29",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    "": "1.3",
    Description: "Additional depth",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description: "Excavation",
    Qty: "477",
    Unit: "m³",
    Rate: "15.85",
    Nett: "£7,560.45",
    "OH&P": "£1,134.07",
    Total: "£8,694.52",
  },
  {
    Description: "Concrete",
    Qty: "348",
    Unit: "m³",
    Rate: "163.01",
    Nett: "£56,727.48",
    "OH&P": "£8,509.12",
    Total: "£65,236.60",
  },
  {
    Description: "Additional trench block",
    Qty: "153",
    Unit: "m²",
    Rate: "94.51",
    Nett: "£14,460.03",
    "OH&P": "£2,169.00",
    Total: "£16,629.03",
  },
  {
    Description: "Additional 100mm block",
    Qty: "162",
    Unit: "m²",
    Rate: "35.04",
    Nett: "£5,676.48",
    "OH&P": "£851.47",
    Total: "£6,527.95",
  },
  {
    Description: "Backfill with as dug arisings",
    Qty: "67",
    Unit: "m³",
    Rate: "6.15",
    Nett: "£411.44",
    "OH&P": "£61.72",
    Total: "£473.15",
  },
  {
    Description: "Deposit surplus arisings onsite",
    Qty: "410",
    Unit: "m³",
    Rate: "2.74",
    Nett: "£1,123.67",
    "OH&P": "£168.55",
    Total: "£1,292.23",
  },
  {
    Description: "Claymaster",
    Qty: "120",
    Unit: "m²",
    Rate: "13.00",
    Nett: "£1,560.00",
    "OH&P": "£234.00",
    Total: "£1,794.00",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    "": "2.0",
    Description: "Piled Foundations",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "",
  },
  {
    Description:
      "Standard 1225mm from FFL (50mm blinding; 500mm reinforced ground beam; 675mm masonry).",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "",
  },
  {
    Description: "Pile matt - see BoQ",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "See BoQ",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "",
  },
  {
    Description: "Setting out for piling contractor",
    Qty: "47",
    Unit: "nr",
    Rate: "77.00",
    Nett: "£3,619.00",
    "OH&P": "£542.85",
    Total: "£4,161.85",
  },
  {
    Description: "Attendance upon piling contractor",
    Qty: "",
    Unit: "nr",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "Included",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "",
  },
  {
    Description: "Pile crop",
    Qty: "602",
    Unit: "nr",
    Rate: "57.75",
    Nett: "£34,765.50",
    "OH&P": "£5,214.82",
    Total: "£39,980.32",
  },
  {
    Description: "Pile collar - where Cordek placed",
    Qty: "602",
    Unit: "nr",
    Rate: "31.00",
    Nett: "£18,662.00",
    "OH&P": "£2,799.30",
    Total: "£21,461.30",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "",
  },
  {
    Description: "Filling steel piles",
    Qty: "",
    Unit: "nr",
    Rate: "110.00",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "Rate Only",
  },
  {
    Description: "Stockpile CFA arisings onsite pending removal",
    Qty: "",
    Unit: "m³",
    Rate: "2.74",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "Rate Only",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "",
  },
  {
    Description: "Rebar - as bar schedules",
    Qty: "43.209",
    Unit: "T",
    Rate: "2,100.00",
    Nett: "£90,738.90",
    "OH&P": "£13,610.84",
    Total: "£104,349.74",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "",
  },
  {
    Description: "External Wall - 600mm wide ringbeam",
    Qty: "1001",
    Unit: "m",
    Rate: "167.67",
    Nett: "£167,837.67",
    "OH&P": "£25,175.65",
    Total: "£193,013.32",
  },
  {
    Description: "External Wall - 1100mm wide ringbeam",
    Qty: "14",
    Unit: "m",
    Rate: "241.28",
    Nett: "£3,377.92",
    "OH&P": "£506.69",
    Total: "£3,884.61",
  },
  {
    Description: "Party Wall - 600mm wide ringbeam",
    Qty: "187",
    Unit: "m",
    Rate: "166.53",
    Nett: "£31,141.11",
    "OH&P": "£4,671.17",
    Total: "£35,812.28",
  },
  {
    Description: "Internal Wall - 600mm ringbeam",
    Qty: "433",
    Unit: "m",
    Rate: "145.40",
    Nett: "£62,958.20",
    "OH&P": "£9,443.73",
    Total: "£72,401.93",
  },
  {
    Description: "Garage External Wall - 600mm wide ringbeam",
    Qty: "255",
    Unit: "m",
    Rate: "147.35",
    Nett: "£37,574.25",
    "OH&P": "£5,636.14",
    Total: "£43,210.39",
  },
  {
    Description: "Garage Internal Wall - 600mm ringbeam",
    Qty: "37",
    Unit: "m",
    Rate: "145.40",
    Nett: "£5,379.80",
    "OH&P": "£806.97",
    Total: "£6,186.77",
  },
  {
    Description: "Tie beam - 300 x 300mm",
    Qty: "36",
    Unit: "m",
    Rate: "66.37",
    Nett: "£2,389.32",
    "OH&P": "£358.40",
    Total: "£2,747.72",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description: "Cordek cellcore HX-B 155mm - incl exc & deposit",
    Qty: "986",
    Unit: "m²",
    Rate: "45.00",
    Nett: "£44,370.00",
    "OH&P": "£6,655.50",
    Total: "£51,025.50",
  },
  {
    Description: "Claymaster 50mm thick",
    Qty: "635",
    Unit: "m²",
    Rate: "13.00",
    Nett: "£8,255.00",
    "OH&P": "£1,238.25",
    Total: "£9,493.25",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    "": "3.0",
    Description: "Abnormals",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description: "EO step at party wall",
    Qty: "",
    Unit: "m²",
    Rate: "45.67",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "Rate Only",
  },
  {
    Description: "Exposed brickwork",
    Qty: "28",
    Unit: "m²",
    Rate: "101.98",
    Nett: "£2,855.44",
    "OH&P": "£428.32",
    Total: "£3,283.76",
  },
  {
    Description: "Tanking (one skin blwk, one skin facings plus tanking)",
    Qty: "49",
    Unit: "m²",
    Rate: "160.00",
    Nett: "£7,840.00",
    "OH&P": "£1,176.00",
    Total: "£9,016.00",
  },
  {
    Description: "EO coloured mortar",
    Qty: "486",
    Unit: "m²",
    Rate: "5.94",
    Nett: "£2,887.50",
    "OH&P": "£433.13",
    Total: "£3,320.63",
  },
  {
    Description: "min visit 6 plots ",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    "": "4.0",
    Description: "Floors",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description:
      "Longley concrete beam & polystyrene infill-panel floor to acehive a 0.15 U-value; 1200g & 500g membrane; minimum 250mm void; 75mm concrete screed with Durus macro-fibres.",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "",
  },
  {
    Description: "B&B houses",
    Qty: "3047",
    Unit: "m²",
    Rate: "97.48",
    Nett: "£297,021.56",
    "OH&P": "£44,553.23",
    Total: "£341,574.79",
  },
  {
    Description: "B&B garages",
    Qty: "815",
    Unit: "m²",
    Rate: "82.37",
    Nett: "£67,131.55",
    "OH&P": "£10,069.73",
    Total: "£77,201.28",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description:
      "150mm thick reinforced concrete paving (top and bottom mesh); 1200g membrane; 150mm thick Kingspan TF70 insulation; 50mm sand blinding; 150mm thick compacted subsoil sub-base.",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description: "House insitu Floor - 150mm thick",
    Qty: "0",
    Unit: "m²",
    Rate: "85.03",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description: "Garage Insitu Floor - 150mm thick",
    Qty: "0",
    Unit: "m²",
    Rate: "52.42",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "",
  },
  {
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "£0.00",
    "OH&P": "£0.00",
    Total: "£0.00",
  },
  {
    Description: "To Summary",
    Qty: "",
    Unit: "",
    Rate: "",
    Nett: "",
    "OH&P": "",
    Total: "£1,261,548.78",
  },
];

// Use the new roads-sewers foul sewers data  
export const foulSewersBillSummary = rsFoulSewers;

export const stormSewersBillSummary = [
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.0",
    Description: "ADOPTED SEWERS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipework, GBS, backfilled with Type 1, deposit surplus material on site ",
    Qty: "",
    Unit: "m",
    Rate: "n/a",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 1.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "90.05",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 1.25m deep",
    Qty: "",
    Unit: "m",
    Rate: "115.45",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 1.50m deep",
    Qty: "",
    Unit: "m",
    Rate: "140.04",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 1.75m deep",
    Qty: "",
    Unit: "m",
    Rate: "165.43",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 2.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "190.05",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 2.25m deep",
    Qty: "",
    Unit: "m",
    Rate: "215.44",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 2.50m deep",
    Qty: "",
    Unit: "m",
    Rate: "277.63",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 2.75m deep",
    Qty: "",
    Unit: "m",
    Rate: "307.76",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 3.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "337.88",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 3.25m deep",
    Qty: "",
    Unit: "m",
    Rate: "368.01",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 3.50m deep",
    Qty: "",
    Unit: "m",
    Rate: "398.15",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 3.75m deep",
    Qty: "",
    Unit: "m",
    Rate: "428.27",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 4.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "458.40",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 4.25m deep",
    Qty: "",
    Unit: "m",
    Rate: "488.51",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 4.50m deep",
    Qty: "",
    Unit: "m",
    Rate: "518.64",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 4.75m deep",
    Qty: "",
    Unit: "m",
    Rate: "548.78",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 5.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "578.91",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 5.25m deep",
    Qty: "",
    Unit: "m",
    Rate: "609.03",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 5.50m deep",
    Qty: "",
    Unit: "m",
    Rate: "639.16",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 5.75m deep",
    Qty: "",
    Unit: "m",
    Rate: "669.28",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 6.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "699.43",
    Amount: "",
  },
  {
    Item: "",
    Description: "EO for 150mmØ stub/rocker pipe",
    Qty: "",
    Unit: "nr",
    Rate: "15.89",
    Amount: "",
  },
  {
    Item: "",
    Description: "EO for 150 x 150mm junction",
    Qty: "",
    Unit: "nr",
    Rate: "76.72",
    Amount: "",
  },
  {
    Item: "",
    Description: "EO for reinforced concrete protection paving to 150mmØ pipe",
    Qty: "",
    Unit: "m",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipework, GBS, backfilled with Type 1, deposit surplus material on site ",
    Qty: "224",
    Unit: "m",
    Rate: "n/a",
    Amount: "£52,898.38",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 1.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "93.22",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 1.25m deep",
    Qty: "",
    Unit: "m",
    Rate: "119.68",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 1.50m deep",
    Qty: "27",
    Unit: "m",
    Rate: "146.96",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 1.75m deep",
    Qty: "126",
    Unit: "m",
    Rate: "173.43",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 2.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "200.69",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 2.25m deep",
    Qty: "",
    Unit: "m",
    Rate: "227.16",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 2.50m deep",
    Qty: "",
    Unit: "m",
    Rate: "277.42",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 2.75m deep",
    Qty: "",
    Unit: "m",
    Rate: "307.55",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 3.00m deep",
    Qty: "32",
    Unit: "m",
    Rate: "337.67",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 3.25m deep",
    Qty: "7",
    Unit: "m",
    Rate: "367.80",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 3.50m deep",
    Qty: "",
    Unit: "m",
    Rate: "397.94",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 3.75m deep",
    Qty: "32",
    Unit: "m",
    Rate: "428.07",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 4.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "458.20",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 4.25m deep",
    Qty: "",
    Unit: "m",
    Rate: "488.30",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 4.50m deep",
    Qty: "",
    Unit: "m",
    Rate: "518.44",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 4.75m deep",
    Qty: "",
    Unit: "m",
    Rate: "548.57",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 5.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "578.70",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 5.25m deep",
    Qty: "",
    Unit: "m",
    Rate: "608.83",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 5.50m deep",
    Qty: "",
    Unit: "m",
    Rate: "638.95",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 5.75m deep",
    Qty: "",
    Unit: "m",
    Rate: "669.08",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 6.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "699.21",
    Amount: "",
  },
  {
    Item: "",
    Description: "EO for 225mmØ stub/rocker pipe",
    Qty: "16",
    Unit: "nr",
    Rate: "43.61",
    Amount: "£697.76",
  },
  {
    Item: "",
    Description: "EO for 225 x 150mm junction",
    Qty: "15",
    Unit: "nr",
    Rate: "111.18",
    Amount: "£1,667.70",
  },
  {
    Item: "",
    Description: "EO for reinforced concrete protection paving to 225mmØ pipe",
    Qty: "17",
    Unit: "m",
    Rate: "95.71",
    Amount: "£1,627.07",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "300mmØ pipework, GBS, backfilled with Type 1, deposit surplus material on site ",
    Qty: "210",
    Unit: "m",
    Rate: "n/a",
    Amount: "£50,778.12",
  },
  {
    Item: "",
    Description: "EO for 300mmØ stub/rocker pipe",
    Qty: "22",
    Unit: "nr",
    Rate: "53.89",
    Amount: "£1,185.58",
  },
  {
    Item: "",
    Description: "EO for 300 x 150mm junction",
    Qty: "18",
    Unit: "nr",
    Rate: "146.33",
    Amount: "£2,633.94",
  },
  {
    Item: "",
    Description: "EO for reinforced concrete protection paving to 300mmØ pipe",
    Qty: "38",
    Unit: "m",
    Rate: "103.05",
    Amount: "£3,915.90",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "375mmØ pipework, GBS, backfilled with Type 1, deposit surplus material on site ",
    Qty: "15",
    Unit: "m",
    Rate: "n/a",
    Amount: "£6,640.81",
  },
  {
    Item: "",
    Description: "EO for 375mmØ stub/rocker pipe",
    Qty: "4",
    Unit: "nr",
    Rate: "71.44",
    Amount: "£285.76",
  },
  {
    Item: "",
    Description: "EO for 375 x 150mm junction",
    Qty: "1",
    Unit: "nr",
    Rate: "185.84",
    Amount: "£185.84",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "450mmØ pipework, GBS, backfilled with Type 1, deposit surplus material on site ",
    Qty: "239",
    Unit: "m",
    Rate: "n/a",
    Amount: "£117,623.76",
  },
  {
    Item: "",
    Description: "EO for 450mmØ stub/rocker pipe",
    Qty: "18",
    Unit: "nr",
    Rate: "88.07",
    Amount: "£1,585.26",
  },
  {
    Item: "",
    Description: "EO for 450 x 150mm junction",
    Qty: "12",
    Unit: "nr",
    Rate: "224.86",
    Amount: "£2,698.32",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "525mmØ pipework, GBS, backfilled with Type 1, deposit surplus material on site ",
    Qty: "70",
    Unit: "m",
    Rate: "n/a",
    Amount: "£28,492.14",
  },
  {
    Item: "",
    Description: "EO for 525mmØ stub/rocker pipe",
    Qty: "6",
    Unit: "nr",
    Rate: "116.60",
    Amount: "£699.60",
  },
  {
    Item: "",
    Description: "EO for core drilling 525mm pipework",
    Qty: "4",
    Unit: "nr",
    Rate: "276.61",
    Amount: "£1,106.44",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "600mmØ pipework, GBS, backfilled with Type 1, deposit surplus material on site ",
    Qty: "19",
    Unit: "m",
    Rate: "n/a",
    Amount: "£6,534.48",
  },
  {
    Item: "",
    Description: "EO for 600mmØ stub/rocker pipe",
    Qty: "4",
    Unit: "nr",
    Rate: "148.35",
    Amount: "£593.40",
  },
  {
    Item: "",
    Description: "EO for core drilling 600mm pipework",
    Qty: "",
    Unit: "nr",
    Rate: "276.61",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "2.0",
    Description: "LATERAL CONNECTIONS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipework, GBS, backfilled with Type 1, deposit surplus material on site ",
    Qty: "119",
    Unit: "m",
    Rate: "n/a",
    Amount: "£30,898.05",
  },
  {
    Item: "",
    Description: "EO for 150mmØ stub/rocker pipe",
    Qty: "34",
    Unit: "nr",
    Rate: "13.77",
    Amount: "£468.18",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ pipework, GBS, backfilled with Type 1, deposit surplus material on site ",
    Qty: "58",
    Unit: "m",
    Rate: "n/a",
    Amount: "£13,974.44",
  },
  {
    Item: "",
    Description: "EO for 225mmØ stub/rocker pipe",
    Qty: "18",
    Unit: "nr",
    Rate: "43.61",
    Amount: "£784.98",
  },
  {
    Item: "",
    Description: "EO for concrete bed & surround to 225mmØ pipe",
    Qty: "7",
    Unit: "m",
    Rate: "37.30",
    Amount: "£261.10",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "3.0",
    Description: "GULLY CONNECTIONS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipework, GBS, backfilled with Type 1, deposit surplus material on site ",
    Qty: "281",
    Unit: "m",
    Rate: "n/a",
    Amount: "£37,738.15",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 1.00m deep",
    Qty: "25",
    Unit: "m",
    Rate: "78.74",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 1.25m deep",
    Qty: "128",
    Unit: "m",
    Rate: "104.14",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 1.50m deep",
    Qty: "58",
    Unit: "m",
    Rate: "128.74",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 1.75m deep",
    Qty: "13",
    Unit: "m",
    Rate: "154.14",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 2.00m deep",
    Qty: "18",
    Unit: "m",
    Rate: "178.75",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 2.25m deep",
    Qty: "17",
    Unit: "m",
    Rate: "204.15",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 2.50m deep",
    Qty: "8",
    Unit: "m",
    Rate: "266.33",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 2.75m deep",
    Qty: "14",
    Unit: "m",
    Rate: "296.45",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 3.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "326.58",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 3.25m deep",
    Qty: "",
    Unit: "m",
    Rate: "356.70",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 3.50m deep",
    Qty: "",
    Unit: "m",
    Rate: "386.86",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 3.75m deep",
    Qty: "",
    Unit: "m",
    Rate: "416.96",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 4.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "447.11",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 4.25m deep",
    Qty: "",
    Unit: "m",
    Rate: "477.20",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 4.50m deep",
    Qty: "",
    Unit: "m",
    Rate: "507.34",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 4.75m deep",
    Qty: "",
    Unit: "m",
    Rate: "537.48",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 5.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "567.61",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 5.25m deep",
    Qty: "",
    Unit: "m",
    Rate: "597.73",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 5.50m deep",
    Qty: "",
    Unit: "m",
    Rate: "627.86",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 5.75m deep",
    Qty: "",
    Unit: "m",
    Rate: "657.98",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "150mmØ pipe, GBS, backfilled with Type 1, deposit surplus on site - 6.00m deep",
    Qty: "",
    Unit: "m",
    Rate: "688.13",
    Amount: "",
  },
  {
    Item: "",
    Description: "EO for 150mmØ stub/rocker pipe",
    Qty: "14",
    Unit: "nr",
    Rate: "13.77",
    Amount: "£192.78",
  },
  {
    Item: "",
    Description: "EO for concrete bed & surround to 150mmØ pipe",
    Qty: "153",
    Unit: "m",
    Rate: "30.06",
    Amount: "£4,599.18",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "4.0",
    Description: "PCC MANHOLES ",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm diameter manhole - Easi Base & WW rings",
    Qty: "12",
    Unit: "nr",
    Rate: "n/a",
    Amount: "£48,227.18",
  },
  {
    Item: "",
    Description: "1200mm dia ave 1.00m dti",
    Qty: "",
    Unit: "nr",
    Rate: "1831.36",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 1.25m dti",
    Qty: "",
    Unit: "nr",
    Rate: "2026.24",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 1.50m dti",
    Qty: "",
    Unit: "nr",
    Rate: "2248.30",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 1.75m dti",
    Qty: "",
    Unit: "nr",
    Rate: "2498.78",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 2.00m dti",
    Qty: "2",
    Unit: "nr",
    Rate: "2721.24",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 2.25m dti",
    Qty: "",
    Unit: "nr",
    Rate: "2916.16",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 2.50m dti",
    Qty: "3",
    Unit: "nr",
    Rate: "3138.18",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 2.75m dti",
    Qty: "1",
    Unit: "nr",
    Rate: "3388.68",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 3.00m dti",
    Qty: "2",
    Unit: "nr",
    Rate: "4174.54",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 3.25m dti",
    Qty: "1",
    Unit: "nr",
    Rate: "4425.77",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 3.50m dti",
    Qty: "",
    Unit: "nr",
    Rate: "4704.15",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 3.75m dti",
    Qty: "1",
    Unit: "nr",
    Rate: "5010.97",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 4.00m dti",
    Qty: "",
    Unit: "nr",
    Rate: "5289.77",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 4.25m dti",
    Qty: "",
    Unit: "nr",
    Rate: "5541.01",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 4.50m dti",
    Qty: "",
    Unit: "nr",
    Rate: "5819.37",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 4.75m dti",
    Qty: "2",
    Unit: "nr",
    Rate: "6097.83",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 5.00m dti",
    Qty: "",
    Unit: "nr",
    Rate: "6405.01",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 5.25m dti",
    Qty: "",
    Unit: "nr",
    Rate: "6656.25",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 5.50m dti",
    Qty: "",
    Unit: "nr",
    Rate: "6934.63",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 5.75m dti",
    Qty: "",
    Unit: "nr",
    Rate: "7241.45",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm dia ave 6.00m dti",
    Qty: "",
    Unit: "nr",
    Rate: "7520.26",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "1350mm diameter manhole - PCC chamber rings",
    Qty: "12",
    Unit: "nr",
    Rate: "n/a",
    Amount: "£32,055.22",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "1500mm diameter manhole - Easi Base & WW rings",
    Qty: "8",
    Unit: "nr",
    Rate: "n/a",
    Amount: "£37,591.65",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "1800mm diameter manhole - Trad Base & WW rings",
    Qty: "1",
    Unit: "nr",
    Rate: "n/a",
    Amount: "£4,191.65",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Flow Control Chamber - 2700mmØ PCC MH at 2.75m dti - 4.6 l/s; 967mm head",
    Qty: "1",
    Unit: "nr",
    Rate: "16550.39",
    Amount: "£16,550.39",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "EO Orifice plate fitted to S33",
    Qty: "1",
    Unit: "nr",
    Rate: "1079.96",
    Amount: "£1,079.96",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "EO construct manhole on existing sewer",
    Qty: "1",
    Unit: "nr",
    Rate: "1027.54",
    Amount: "£1,027.54",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Supply and fit temporary debris grille to outfall manhole",
    Qty: "1",
    Unit: "nr",
    Rate: "1481.70",
    Amount: "£1,481.70",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "5.0",
    Description: "PCC ROAD GULLEY",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Precast concrete road gulley 450 x 900 inc grate & frame ",
    Qty: "64",
    Unit: "nr",
    Rate: "441.78",
    Amount: "£28,273.92",
  },
  {
    Item: "",
    Description: "Hessian and straw protection to gully",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Included",
  },
  {
    Item: "",
    Description: "Preformed gully guards",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "6.0",
    Description: "DEMARCATION CHAMBERS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "1200mm diameter manhole - PCC chamber rings",
    Qty: "26",
    Unit: "nr",
    Rate: "n/a",
    Amount: "£77,633.96",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Backdrops to PPC Chambers",
    Qty: "15",
    Unit: "nr",
    Rate: "511.56",
    Amount: "£7,673.40",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "7.0",
    Description: "PONDS, SWALES & HEADWALLS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Pond 1 ",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Site strip to remove vegetation",
    Qty: "3059",
    Unit: "m²",
    Rate: "1.41",
    Amount: "£4,313.19",
  },
  {
    Item: "",
    Description:
      "Excavate to reduce levels to take up 296mm top soil, deposit onsite",
    Qty: "905",
    Unit: "m³",
    Rate: "5.76",
    Amount: "£5,212.80",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Excavate to reduce levels",
    Qty: "5536",
    Unit: "m³",
    Rate: "5.76",
    Amount: "£31,887.36",
  },
  {
    Item: "",
    Description: "Filling with site won subsoil",
    Qty: "",
    Unit: "m³",
    Rate: "8.09",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Level and compact formation, batter embankments",
    Qty: "3162",
    Unit: "m²",
    Rate: "1.23",
    Amount: "£3,889.26",
  },
  {
    Item: "",
    Description: "Pond lining or puddle clay - no details",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Spread and level 150mm thick top soil",
    Qty: "3162",
    Unit: "m²",
    Rate: "3.11",
    Amount: "£9,833.82",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Surface Water Flood Alleviation",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Site strip to remove vegetation",
    Qty: "203",
    Unit: "m²",
    Rate: "1.41",
    Amount: "£286.23",
  },
  {
    Item: "",
    Description:
      "Excavate to reduce levels to take up 296mm top soil, deposit onsite",
    Qty: "60",
    Unit: "m³",
    Rate: "5.76",
    Amount: "£345.60",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Excavate to reduce levels",
    Qty: "28",
    Unit: "m³",
    Rate: "5.76",
    Amount: "£161.28",
  },
  {
    Item: "",
    Description: "Filling with site won subsoil",
    Qty: "1",
    Unit: "m³",
    Rate: "8.09",
    Amount: "£8.09",
  },
  {
    Item: "",
    Description: "Level and compact formation, batter embankments",
    Qty: "208",
    Unit: "m²",
    Rate: "1.23",
    Amount: "£255.84",
  },
  {
    Item: "",
    Description: "Pond lining or puddle clay - no details",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Spread and level 150mm thick top soil",
    Qty: "208",
    Unit: "m²",
    Rate: "3.11",
    Amount: "£646.88",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Outfall Watercourse Route",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Site strip to remove vegetation",
    Qty: "1462",
    Unit: "m²",
    Rate: "1.41",
    Amount: "£2,061.42",
  },
  {
    Item: "",
    Description:
      "Excavate to reduce levels to take up 296mm top soil, deposit onsite",
    Qty: "433",
    Unit: "m³",
    Rate: "5.76",
    Amount: "£2,494.08",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Excavate to reduce levels",
    Qty: "1216",
    Unit: "m³",
    Rate: "5.76",
    Amount: "£7,004.16",
  },
  {
    Item: "",
    Description: "Filling with site won subsoil",
    Qty: "723",
    Unit: "m³",
    Rate: "8.09",
    Amount: "£5,849.07",
  },
  {
    Item: "",
    Description: "Level and compact formation, batter embankments",
    Qty: "1858",
    Unit: "m²",
    Rate: "1.23",
    Amount: "£2,285.34",
  },
  {
    Item: "",
    Description: "Pond lining or puddle clay - no details",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Spread and level 150mm thick top soil",
    Qty: "1858",
    Unit: "m²",
    Rate: "3.11",
    Amount: "£5,778.38",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "225mmØ filter drain, backfilled with clean stone - under watercourse, if required",
    Qty: "298",
    Unit: "m",
    Rate: "149.01",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Headwall to suit 225mmØ pipe - HW4",
    Qty: "1",
    Unit: "nr",
    Rate: "5503.53",
    Amount: "£5,503.53",
  },
  {
    Item: "",
    Description: "Headwall to suit 300mmØ pipe - HW2",
    Qty: "1",
    Unit: "nr",
    Rate: "5503.53",
    Amount: "£5,503.53",
  },
  {
    Item: "",
    Description: "Headwall to suit 525mmØ pipe - HW3",
    Qty: "1",
    Unit: "nr",
    Rate: "7130.70",
    Amount: "£7,130.70",
  },
  {
    Item: "",
    Description: "Headwall to suit 600mmØ pipe - HW1 & HW5",
    Qty: "2",
    Unit: "nr",
    Rate: "7130.70",
    Amount: "£14,261.40",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Civilise existing ditchcourse immediately adjacent outfall headwall",
    Qty: "2",
    Unit: "item",
    Rate: "605.76",
    Amount: "£1,211.52",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "8.0",
    Description: "CULVERTS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Box Culvert - 1000mm wide x 500mm deep x 2000mm length, GBS, backfilled with type 1, deposit surplus onsite",
    Qty: "27",
    Unit: "m",
    Rate: "1306.91",
    Amount: "£35,286.57",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Grout / grub up redundant Culvert - n ex 450mmØ",
    Qty: "26",
    Unit: "m",
    Rate: "34.10",
    Amount: "£886.60",
  },
  {
    Item: "",
    Description: "Headwalls to Box Culvert",
    Qty: "2",
    Unit: "nr",
    Rate: "6690.33",
    Amount: "£13,380.66",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "9.0",
    Description: "REMOVAL OF REDUNDANT SEWER",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Grout / grub up redundant Culvert - n ex 225mmØ",
    Qty: "13",
    Unit: "m",
    Rate: "25.49",
    Amount: "£331.37",
  },
  {
    Item: "",
    Description: "Grout / grub up redundant Culvert - n ex 300mmØ",
    Qty: "187",
    Unit: "m",
    Rate: "34.10",
    Amount: "£6,376.70",
  },
  {
    Item: "",
    Description: "Replace with 450mmØ Culvert - Prov Sum no Details or Designs",
    Qty: "13",
    Unit: "m",
    Rate: "265.76",
    Amount: "£3,454.88",
  },
  {
    Item: "",
    Description: "Headwalls to suit 450mmØ Culvert - Provisional sum",
    Qty: "2",
    Unit: "m",
    Rate: "300.50",
    Amount: "£601.00",
  },
  {
    Item: "",
    Description: "Break out existing manhole, remove from site",
    Qty: "",
    Unit: "nr",
    Rate: "533.17",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Carried forward to summary",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "£802,794.95",
  },
];

// Use the new roads-sewers sum analysis data
export const sumAnalysisBillSummary = rsSumAnalysis;

export const roadsBillSummary = [
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.0",
    Description: "SITE CLEARANCE & EARTHWORKS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Site strip to remove vegetation",
    Qty: "6984",
    Unit: "m²",
    Rate: "1.41",
    Amount: "£9,847.44",
  },
  {
    Item: "",
    Description:
      "Excavate to reduce levels to take up 296mm top soil, deposit onsite",
    Qty: "2067",
    Unit: "m³",
    Rate: "5.76",
    Amount: "£11,905.92",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "2.0",
    Description: "EXCAVATING & FILLING",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Excavate to reduce levels",
    Qty: "100",
    Unit: "m³",
    Rate: "5.76",
    Amount: "£576.00",
  },
  {
    Item: "",
    Description: "Filling with site won subsoil to paths",
    Qty: "1665",
    Unit: "m³",
    Rate: "8.09",
    Amount: "£13,469.85",
  },
  {
    Item: "",
    Description: "Filling with recycled 6F2 to roads",
    Qty: "1243",
    Unit: "m³",
    Rate: "49.71",
    Amount: "£61,789.53",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Level and compact formation",
    Qty: "6984",
    Unit: "m²",
    Rate: "0.94",
    Amount: "£6,564.96",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "3.0",
    Description: "CARRIAGEWAY ",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "3.1",
    Description: "Macadam Access Road",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "225mm thick MOT Type 1",
    Qty: "4235",
    Unit: "m²",
    Rate: "16.66",
    Amount: "£70,555.10",
  },
  {
    Item: "",
    Description: "125mm thick AC 32mm DBM base course",
    Qty: "3431",
    Unit: "m²",
    Rate: "37.17",
    Amount: "£127,530.27",
  },
  {
    Item: "",
    Description: "60mm thick AC 20mm DBM binder course",
    Qty: "3431",
    Unit: "m²",
    Rate: "17.84",
    Amount: "£61,209.04",
  },
  {
    Item: "",
    Description: "Sealing grit",
    Qty: "3431",
    Unit: "m²",
    Rate: "0.72",
    Amount: "£2,470.32",
  },
  {
    Item: "",
    Description: "Sweep tack",
    Qty: "3431",
    Unit: "m²",
    Rate: "1.03",
    Amount: "£3,533.93",
  },
  {
    Item: "",
    Description: "40mm thick HRA 55/10F (n ex psv60) surface course",
    Qty: "3431",
    Unit: "m²",
    Rate: "19.29",
    Amount: "£66,183.99",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "3.2",
    Description: "Block Paved Access Way",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "225mm thick MOT Type 1",
    Qty: "569",
    Unit: "m²",
    Rate: "16.66",
    Amount: "£9,479.54",
  },
  {
    Item: "",
    Description: "125mm thick AC 32mm DBM base course",
    Qty: "461",
    Unit: "m²",
    Rate: "37.17",
    Amount: "£17,135.37",
  },
  {
    Item: "",
    Description: "Sealing grit",
    Qty: "461",
    Unit: "m²",
    Rate: "0.72",
    Amount: "£331.92",
  },
  {
    Item: "",
    Description: "Sweep",
    Qty: "461",
    Unit: "m²",
    Rate: "0.39",
    Amount: "£179.79",
  },
  {
    Item: "",
    Description: "200 x 100 x 80mm block paviour on 30mm sand bed",
    Qty: "461",
    Unit: "m²",
    Rate: "48.37",
    Amount: "£22,298.57",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "EO retrofit ramp in delineation from macadam to block paved",
    Qty: "4",
    Unit: "nr",
    Rate: "1364.35",
    Amount: "£5,457.40",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "EO form joint to existing carriageway - if required",
    Qty: "",
    Unit: "m",
    Rate: "43.01",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "4.0",
    Description: "FOOTPATHS, VEHICLE CROSSOVERS & VERGES ",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "4.1",
    Description: "Tarmac Footpath",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "200mm thick MOT Type 1",
    Qty: "1574",
    Unit: "m²",
    Rate: "14.80",
    Amount: "£23,295.20",
  },
  {
    Item: "",
    Description: "80mm thick AC 20mm DBM binder course",
    Qty: "1574",
    Unit: "m²",
    Rate: "34.26",
    Amount: "£53,925.24",
  },
  {
    Item: "",
    Description: "Sweep tack ",
    Qty: "1574",
    Unit: "m²",
    Rate: "1.03",
    Amount: "£1,621.22",
  },
  {
    Item: "",
    Description: "20mm thick AC 6mm DBM surface course",
    Qty: "1574",
    Unit: "m²",
    Rate: "16.21",
    Amount: "£25,514.54",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "4.2",
    Description: "Tarmac Crossover",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "200mm thick MOT Type 1",
    Qty: "1027",
    Unit: "m²",
    Rate: "14.80",
    Amount: "£15,199.60",
  },
  {
    Item: "",
    Description: "80mm thick AC 20mm DBM binder course",
    Qty: "1027",
    Unit: "m²",
    Rate: "34.46",
    Amount: "£35,390.42",
  },
  {
    Item: "",
    Description: "Sweep tack ",
    Qty: "1027",
    Unit: "m²",
    Rate: "1.03",
    Amount: "£1,057.81",
  },
  {
    Item: "",
    Description: "25mm thick AC 6mm DBM surface course",
    Qty: "1027",
    Unit: "m²",
    Rate: "17.05",
    Amount: "£17,510.35",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "4.3",
    Description: "Verges",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Spread and level 150mm thick top soil",
    Qty: "491",
    Unit: "m²",
    Rate: "3.25",
    Amount: "£1,595.75",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Carried forward to summary",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "£665,629.07",
  },
  {
    Item: "",
    Description: "M & J EVANS CONSTRUCTION LIMITED",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },

  {
    Item: "",
    Description: "S38 WORKS TO ACHIEVE 5%+ CBR",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "Item",
    Description: "Description",
    Qty: "Qty",
    Unit: "Unit",
    Rate: "Rate",
    Amount: "Amount",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "5.0",
    Description: "KERBS & EDGINGS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Pcc Kerbs - All Sizes",
    Qty: "1311",
    Unit: "m",
    Rate: "68.75",
    Amount: "£90,131.25",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "EO for 16mmØ dowel to kerb race at 450mm ccs",
    Qty: "2913",
    Unit: "nr",
    Rate: "5.62",
    Amount: "£16,371.06",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Channel Kerbs to Block Paved Ramps",
    Qty: "46",
    Unit: "m",
    Rate: "68.75",
    Amount: "£3,162.50",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Temporary macadam fillet to drive crossover prior to road surfacing",
    Qty: "490",
    Unit: "m",
    Rate: "9.41",
    Amount: "£4,610.90",
  },
  {
    Item: "",
    Description: "Remove macadam fillet upon completion",
    Qty: "490",
    Unit: "m",
    Rate: "7.21",
    Amount: "£3,532.90",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "150 x 50 pcc edging",
    Qty: "664",
    Unit: "m",
    Rate: "22.39",
    Amount: "£14,866.96",
  },
  {
    Item: "",
    Description: "Tactiles",
    Qty: "16",
    Unit: "nr",
    Rate: "505.34",
    Amount: "£8,085.44",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "6.0",
    Description: "ADJUST IRONWORK PRIOR TO FINAL SURFACING",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Manholes",
    Qty: "48",
    Unit: "nr",
    Rate: "157.98",
    Amount: "£7,583.04",
  },
  {
    Item: "",
    Description: "Gully covers and frames",
    Qty: "64",
    Unit: "nr",
    Rate: "120.24",
    Amount: "£7,695.36",
  },
  {
    Item: "",
    Description:
      "Stop Tap Boxes                                               ",
    Qty: "114",
    Unit: "nr",
    Rate: "59.93",
    Amount: "£6,832.02",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "7.0",
    Description: "WHITE LINING",
    Qty: "1",
    Unit: "item",
    Rate: "3176.79",
    Amount: "£3,176.79",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "8.0",
    Description: "FIX-ONLY STREET NAMEPLATES",
    Qty: "10",
    Unit: "nr",
    Rate: "223.31",
    Amount: "£2,233.10",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "9.0",
    Description: "TREE PITS, BOLLARDS & STREET FURNITURE",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "10.0",
    Description: "REMEDIALS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Carried forward to summary",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "£168,281.32",
  },
];

export const mainServicesBillSummary = [
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.0",
    Description: "MAIN SERVICE TRENCHING",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Water main trenching",
    Qty: "1245",
    Unit: "m",
    Rate: "25.32",
    Amount: "£31,523.40",
  },
  {
    Item: "",
    Description: "Road crossing duct n ex 150mmØ",
    Qty: "171",
    Unit: "m",
    Rate: "67.77",
    Amount: "£11,588.67",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Electric LV main trenching",
    Qty: "1272",
    Unit: "m",
    Rate: "23.41",
    Amount: "£29,777.52",
  },
  {
    Item: "",
    Description: "Road crossing duct n ex 150mmØ",
    Qty: "184",
    Unit: "m",
    Rate: "67.77",
    Amount: "£12,469.68",
  },
  {
    Item: "",
    Description: "Electric HV main trenching to substation",
    Qty: "",
    Unit: "m",
    Rate: "23.41",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Substation base & maintenance drive",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Gas main trenching",
    Qty: "",
    Unit: "m",
    Rate: "23.41",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "BT main ducting",
    Qty: "1233",
    Unit: "m",
    Rate: "20.57",
    Amount: "£25,362.81",
  },
  {
    Item: "",
    Description: "Road crossing duct n ex 150mmØ",
    Qty: "173",
    Unit: "m",
    Rate: "67.77",
    Amount: "£11,724.21",
  },
  {
    Item: "",
    Description: "BT Joint Box JBF 104",
    Qty: "",
    Unit: "nr",
    Rate: "478.23",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "BT Joint Box JBF 104C 750mm deep",
    Qty: "",
    Unit: "nr",
    Rate: "998.95",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "BT Joint Box JBF 106D 900 deep",
    Qty: "",
    Unit: "nr",
    Rate: "1160.52",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "BT Joint Box JBF 106 1200 deep",
    Qty: "",
    Unit: "nr",
    Rate: "1545.27",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "BT Joint Box JBF 104 (utilising pre-formed Stakkabox)",
    Qty: "",
    Unit: "nr",
    Rate: "791.69",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description:
      "BT Joint Box JBF 104C 750mm deep (utilising pre-formed Stakkabox)",
    Qty: "",
    Unit: "nr",
    Rate: "1167.74",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description:
      "BT Joint Box JBF 106D 900 deep (utilising pre-formed Stakkabox)",
    Qty: "",
    Unit: "nr",
    Rate: "1338.86",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description:
      "BT Joint Box JBF 106 1200 deep (utilising pre-formed Stakkabox)",
    Qty: "",
    Unit: "nr",
    Rate: "1770.84",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Virgin Media main ducting",
    Qty: "",
    Unit: "m",
    Rate: "20.57",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Virgin Footway Box FW4",
    Qty: "",
    Unit: "nr",
    Rate: "824.02",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Virgin Footway Box FW6",
    Qty: "",
    Unit: "nr",
    Rate: "1151.37",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Virgin Footway Box FW10",
    Qty: "",
    Unit: "nr",
    Rate: "1815.39",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Streetlighting main",
    Qty: "",
    Unit: "m",
    Rate: "23.41",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Streetlight connection pits",
    Qty: "",
    Unit: "nr",
    Rate: "561.13",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Streetlights & columns",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "Excluded",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Road crossing duct n ex 150mmØ",
    Qty: "",
    Unit: "m",
    Rate: "67.90",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "225mmØ duct",
    Qty: "",
    Unit: "m",
    Rate: "88.94",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "300mmØ duct",
    Qty: "",
    Unit: "m",
    Rate: "115.58",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "450mmØ duct",
    Qty: "",
    Unit: "m",
    Rate: "",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "600mmØ duct",
    Qty: "",
    Unit: "m",
    Rate: "",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "EO for excavating service trenches off site in 'live' footway",
    Qty: "",
    Unit: "m",
    Rate: "189.58",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Carried forward to summary",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "£122,446.29",
  },
];

export const preliminariesBillSummary = [
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "1.0",
    Description: "METHOD RELATED ITEMS",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Principal Contractor - Fixed Costs",
    Qty: "1",
    Unit: "item",
    Rate: "18045.00",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Principal Contractor - Weekly Costs",
    Qty: "12",
    Unit: "wks",
    Rate: "2395.00",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "S106 applications",
    Qty: "1",
    Unit: "item",
    Rate: "1000.00",
    Amount: "£1,000.00",
  },
  {
    Item: "",
    Description: "License to discharge",
    Qty: "1",
    Unit: "item",
    Rate: "1000.00",
    Amount: "£1,000.00",
  },
  {
    Item: "",
    Description: "S50 applications",
    Qty: "1",
    Unit: "item",
    Rate: "1100.00",
    Amount: "£1,100.00",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "CBR tests",
    Qty: "1",
    Unit: "item",
    Rate: "2461.00",
    Amount: "£2,461.00",
  },
  {
    Item: "",
    Description: "Binder and grading analysis",
    Qty: "1",
    Unit: "item",
    Rate: "2040.00",
    Amount: "£2,040.00",
  },
  {
    Item: "",
    Description: "NDT's",
    Qty: "1",
    Unit: "item",
    Rate: "2500.00",
    Amount: "£2,500.00",
  },
  {
    Item: "",
    Description: "Core testing",
    Qty: "1",
    Unit: "item",
    Rate: "3243.33",
    Amount: "£3,243.33",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Jetting & CCTV of installed sewers; once",
    Qty: "1",
    Unit: "item",
    Rate: "9195.00",
    Amount: "£9,195.00",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Cleaning of manholes prior to surfacing",
    Qty: "1",
    Unit: "item",
    Rate: "4930.00",
    Amount: "£4,930.00",
  },
  {
    Item: "",
    Description: "Cleaning of gullies prior to surfacing",
    Qty: "1",
    Unit: "item",
    Rate: "3520.00",
    Amount: "£3,520.00",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "2.0",
    Description: "TREE PROTECTION FENCING",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "2.1",
    Description: "Tree Protection Fencing As BS 5837:2012 Figure 3a",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Supply and erection of heras fencing on rubber feet.  Fencing to be supported every panel by a scaffold stabilizer strut at 45' with ground pins.",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Supply of heras, rubber feet, clips and stabiliser strut",
    Qty: "",
    Unit: "m",
    Rate: "21.44",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Erect heras fencing on feet",
    Qty: "",
    Unit: "m",
    Rate: "7.43",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Dismantle heras fencing upon completion",
    Qty: "",
    Unit: "m",
    Rate: "7.43",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "2.2",
    Description: "High Intensity Tree Protection Barrier",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description:
      "Supply and erect a scaffold frame driven 600mm into the ground, to which 3.5m heras fence panels are clipped and tied.",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Supply of heras, scaffold poles, couplers & ties",
    Qty: "",
    Unit: "m",
    Rate: "44.37",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Erect heras fencing on poles",
    Qty: "",
    Unit: "m",
    Rate: "37.75",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Dismantle heras fencing upon completion",
    Qty: "",
    Unit: "m",
    Rate: "28.95",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "3.0",
    Description: "BOUNDARY PROTECTION FENCING",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Supply and erect heras fencing on rubber feet.",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Supply of heras, rubber feet & clips",
    Qty: "",
    Unit: "m",
    Rate: "15.98",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Erect heras fencing on feet",
    Qty: "",
    Unit: "m",
    Rate: "6.75",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "Dismantle heras fencing upon completion",
    Qty: "",
    Unit: "m",
    Rate: "6.75",
    Amount: "Rate Only",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "",
  },
  {
    Item: "",
    Description: "Carried forward to summary",
    Qty: "",
    Unit: "",
    Rate: "",
    Amount: "£30,989.33",
  },
];
